/* eslint-disable */
// @ts-nocheck
// THIS FILE IS GENERATED, DO NOT EDIT
// Regenerate the file by running 'yarn compile:ajv'
'use strict';
import { fullFormats } from 'ajv-formats/dist/formats';
const formatWrapper = { ...fullFormats };
function ucs2length(str) {
    const len = str.length;
    let length = 0;
    let pos = 0;
    let value;
    while (pos < len) {
        length++;
        value = str.charCodeAt(pos++);
        if (value >= 0xd800 && value <= 0xdbff && pos < len) {
            value = str.charCodeAt(pos);
            if ((value & 0xfc00) === 0xdc00)
                pos++;
        }
    }
    return length;
}
function ajvEqual(a, b) {
    if (a === b)
        return true;
    if (a && b && typeof a == 'object' && typeof b == 'object') {
        if (a.constructor !== b.constructor)
            return false;
        var length, i, keys;
        if (Array.isArray(a)) {
            length = a.length;
            if (length != b.length)
                return false;
            for (i = length; i-- !== 0;)
                if (!ajvEqual(a[i], b[i]))
                    return false;
            return true;
        }
        if (a.constructor === RegExp)
            return a.source === b.source && a.flags === b.flags;
        if (a.valueOf !== Object.prototype.valueOf)
            return a.valueOf() === b.valueOf();
        if (a.toString !== Object.prototype.toString)
            return a.toString() === b.toString();
        keys = Object.keys(a);
        length = keys.length;
        if (length !== Object.keys(b).length)
            return false;
        for (i = length; i-- !== 0;)
            if (!Object.prototype.hasOwnProperty.call(b, keys[i]))
                return false;
        for (i = length; i-- !== 0;) {
            var key = keys[i];
            if (!ajvEqual(a[key], b[key]))
                return false;
        }
        return true;
    }
    return a !== a && b !== b;
}
export const actionRuleSchemaValidation = validate12;
const schema29 = {
    $id: 'urn:wisepipe-domain-authorize:ActionRule',
    type: 'object',
    properties: {
        resourceType: { type: 'number', enum: [1, 2, 3, 4, 5, 6, 7, 8] },
        action: { type: 'number', enum: [1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11] }
    },
    required: ['resourceType', 'action']
};
function validate12(data, { instancePath = '', parentData, parentDataProperty, rootData = data } = {}) {
    /*# sourceURL="urn:wisepipe-domain-authorize:ActionRule" */ let vErrors = null;
    let errors = 0;
    if (errors === 0) {
        if (data && typeof data == 'object' && !Array.isArray(data)) {
            let missing0;
            if ((data.resourceType === undefined && (missing0 = 'resourceType')) ||
                (data.action === undefined && (missing0 = 'action'))) {
                validate12.errors = [
                    {
                        instancePath,
                        schemaPath: '#/required',
                        keyword: 'required',
                        params: { missingProperty: missing0 },
                        message: "must have required property '" + missing0 + "'"
                    }
                ];
                return false;
            }
            else {
                if (data.resourceType !== undefined) {
                    let data0 = data.resourceType;
                    const _errs1 = errors;
                    if (!(typeof data0 == 'number')) {
                        validate12.errors = [
                            {
                                instancePath: instancePath + '/resourceType',
                                schemaPath: '#/properties/resourceType/type',
                                keyword: 'type',
                                params: { type: 'number' },
                                message: 'must be number'
                            }
                        ];
                        return false;
                    }
                    if (!(data0 === 1 ||
                        data0 === 2 ||
                        data0 === 3 ||
                        data0 === 4 ||
                        data0 === 5 ||
                        data0 === 6 ||
                        data0 === 7 ||
                        data0 === 8)) {
                        validate12.errors = [
                            {
                                instancePath: instancePath + '/resourceType',
                                schemaPath: '#/properties/resourceType/enum',
                                keyword: 'enum',
                                params: { allowedValues: schema29.properties.resourceType.enum },
                                message: 'must be equal to one of the allowed values'
                            }
                        ];
                        return false;
                    }
                    var valid0 = _errs1 === errors;
                }
                else {
                    var valid0 = true;
                }
                if (valid0) {
                    if (data.action !== undefined) {
                        let data1 = data.action;
                        const _errs3 = errors;
                        if (!(typeof data1 == 'number')) {
                            validate12.errors = [
                                {
                                    instancePath: instancePath + '/action',
                                    schemaPath: '#/properties/action/type',
                                    keyword: 'type',
                                    params: { type: 'number' },
                                    message: 'must be number'
                                }
                            ];
                            return false;
                        }
                        if (!(data1 === 1 ||
                            data1 === 2 ||
                            data1 === 3 ||
                            data1 === 4 ||
                            data1 === 5 ||
                            data1 === 6 ||
                            data1 === 7 ||
                            data1 === 8 ||
                            data1 === 9 ||
                            data1 === 10 ||
                            data1 === 11)) {
                            validate12.errors = [
                                {
                                    instancePath: instancePath + '/action',
                                    schemaPath: '#/properties/action/enum',
                                    keyword: 'enum',
                                    params: { allowedValues: schema29.properties.action.enum },
                                    message: 'must be equal to one of the allowed values'
                                }
                            ];
                            return false;
                        }
                        var valid0 = _errs3 === errors;
                    }
                    else {
                        var valid0 = true;
                    }
                }
            }
        }
        else {
            validate12.errors = [
                { instancePath, schemaPath: '#/type', keyword: 'type', params: { type: 'object' }, message: 'must be object' }
            ];
            return false;
        }
    }
    validate12.errors = vErrors;
    return errors === 0;
}
export const feedbackSchemaValidation = validate13;
const schema30 = {
    $id: 'urn:wisepipe-domain-authorize:Feedback',
    type: 'object',
    properties: { feedback: { type: 'string', minLength: 1 } },
    required: ['feedback']
};
const func2 = ucs2length;
function validate13(data, { instancePath = '', parentData, parentDataProperty, rootData = data } = {}) {
    /*# sourceURL="urn:wisepipe-domain-authorize:Feedback" */ let vErrors = null;
    let errors = 0;
    if (errors === 0) {
        if (data && typeof data == 'object' && !Array.isArray(data)) {
            let missing0;
            if (data.feedback === undefined && (missing0 = 'feedback')) {
                validate13.errors = [
                    {
                        instancePath,
                        schemaPath: '#/required',
                        keyword: 'required',
                        params: { missingProperty: missing0 },
                        message: "must have required property '" + missing0 + "'"
                    }
                ];
                return false;
            }
            else {
                if (data.feedback !== undefined) {
                    let data0 = data.feedback;
                    const _errs1 = errors;
                    if (errors === _errs1) {
                        if (typeof data0 === 'string') {
                            if (func2(data0) < 1) {
                                validate13.errors = [
                                    {
                                        instancePath: instancePath + '/feedback',
                                        schemaPath: '#/properties/feedback/minLength',
                                        keyword: 'minLength',
                                        params: { limit: 1 },
                                        message: 'must NOT have fewer than 1 characters'
                                    }
                                ];
                                return false;
                            }
                        }
                        else {
                            validate13.errors = [
                                {
                                    instancePath: instancePath + '/feedback',
                                    schemaPath: '#/properties/feedback/type',
                                    keyword: 'type',
                                    params: { type: 'string' },
                                    message: 'must be string'
                                }
                            ];
                            return false;
                        }
                    }
                }
            }
        }
        else {
            validate13.errors = [
                { instancePath, schemaPath: '#/type', keyword: 'type', params: { type: 'object' }, message: 'must be object' }
            ];
            return false;
        }
    }
    validate13.errors = vErrors;
    return errors === 0;
}
export const incentivesRoleSchemaValidation = validate14;
const schema31 = {
    $id: 'urn:wisepipe-domain-authorize:IncentivesRole',
    type: 'object',
    properties: {
        orgID: { type: 'string', format: 'uuid' },
        roleID: { type: 'string', format: 'uuid' },
        users: { type: 'array', items: { type: 'string', format: 'uuid' } },
        permissions: {
            type: 'object',
            additionalProperties: { type: 'array', items: { type: 'string', enum: ['view', 'edit', 'run'] } }
        }
    },
    required: ['orgID', 'roleID', 'users', 'permissions']
};
const formats0 = /^(?:urn:uuid:)?[0-9a-f]{8}-(?:[0-9a-f]{4}-){3}[0-9a-f]{12}$/i;
function validate14(data, { instancePath = '', parentData, parentDataProperty, rootData = data } = {}) {
    /*# sourceURL="urn:wisepipe-domain-authorize:IncentivesRole" */ let vErrors = null;
    let errors = 0;
    if (errors === 0) {
        if (data && typeof data == 'object' && !Array.isArray(data)) {
            let missing0;
            if ((data.orgID === undefined && (missing0 = 'orgID')) ||
                (data.roleID === undefined && (missing0 = 'roleID')) ||
                (data.users === undefined && (missing0 = 'users')) ||
                (data.permissions === undefined && (missing0 = 'permissions'))) {
                validate14.errors = [
                    {
                        instancePath,
                        schemaPath: '#/required',
                        keyword: 'required',
                        params: { missingProperty: missing0 },
                        message: "must have required property '" + missing0 + "'"
                    }
                ];
                return false;
            }
            else {
                if (data.orgID !== undefined) {
                    let data0 = data.orgID;
                    const _errs1 = errors;
                    if (errors === _errs1) {
                        if (errors === _errs1) {
                            if (typeof data0 === 'string') {
                                if (!formats0.test(data0)) {
                                    validate14.errors = [
                                        {
                                            instancePath: instancePath + '/orgID',
                                            schemaPath: '#/properties/orgID/format',
                                            keyword: 'format',
                                            params: { format: 'uuid' },
                                            message: 'must match format "' + 'uuid' + '"'
                                        }
                                    ];
                                    return false;
                                }
                            }
                            else {
                                validate14.errors = [
                                    {
                                        instancePath: instancePath + '/orgID',
                                        schemaPath: '#/properties/orgID/type',
                                        keyword: 'type',
                                        params: { type: 'string' },
                                        message: 'must be string'
                                    }
                                ];
                                return false;
                            }
                        }
                    }
                    var valid0 = _errs1 === errors;
                }
                else {
                    var valid0 = true;
                }
                if (valid0) {
                    if (data.roleID !== undefined) {
                        let data1 = data.roleID;
                        const _errs3 = errors;
                        if (errors === _errs3) {
                            if (errors === _errs3) {
                                if (typeof data1 === 'string') {
                                    if (!formats0.test(data1)) {
                                        validate14.errors = [
                                            {
                                                instancePath: instancePath + '/roleID',
                                                schemaPath: '#/properties/roleID/format',
                                                keyword: 'format',
                                                params: { format: 'uuid' },
                                                message: 'must match format "' + 'uuid' + '"'
                                            }
                                        ];
                                        return false;
                                    }
                                }
                                else {
                                    validate14.errors = [
                                        {
                                            instancePath: instancePath + '/roleID',
                                            schemaPath: '#/properties/roleID/type',
                                            keyword: 'type',
                                            params: { type: 'string' },
                                            message: 'must be string'
                                        }
                                    ];
                                    return false;
                                }
                            }
                        }
                        var valid0 = _errs3 === errors;
                    }
                    else {
                        var valid0 = true;
                    }
                    if (valid0) {
                        if (data.users !== undefined) {
                            let data2 = data.users;
                            const _errs5 = errors;
                            if (errors === _errs5) {
                                if (Array.isArray(data2)) {
                                    var valid1 = true;
                                    const len0 = data2.length;
                                    for (let i0 = 0; i0 < len0; i0++) {
                                        let data3 = data2[i0];
                                        const _errs7 = errors;
                                        if (errors === _errs7) {
                                            if (errors === _errs7) {
                                                if (typeof data3 === 'string') {
                                                    if (!formats0.test(data3)) {
                                                        validate14.errors = [
                                                            {
                                                                instancePath: instancePath + '/users/' + i0,
                                                                schemaPath: '#/properties/users/items/format',
                                                                keyword: 'format',
                                                                params: { format: 'uuid' },
                                                                message: 'must match format "' + 'uuid' + '"'
                                                            }
                                                        ];
                                                        return false;
                                                    }
                                                }
                                                else {
                                                    validate14.errors = [
                                                        {
                                                            instancePath: instancePath + '/users/' + i0,
                                                            schemaPath: '#/properties/users/items/type',
                                                            keyword: 'type',
                                                            params: { type: 'string' },
                                                            message: 'must be string'
                                                        }
                                                    ];
                                                    return false;
                                                }
                                            }
                                        }
                                        var valid1 = _errs7 === errors;
                                        if (!valid1) {
                                            break;
                                        }
                                    }
                                }
                                else {
                                    validate14.errors = [
                                        {
                                            instancePath: instancePath + '/users',
                                            schemaPath: '#/properties/users/type',
                                            keyword: 'type',
                                            params: { type: 'array' },
                                            message: 'must be array'
                                        }
                                    ];
                                    return false;
                                }
                            }
                            var valid0 = _errs5 === errors;
                        }
                        else {
                            var valid0 = true;
                        }
                        if (valid0) {
                            if (data.permissions !== undefined) {
                                let data4 = data.permissions;
                                const _errs9 = errors;
                                if (errors === _errs9) {
                                    if (data4 && typeof data4 == 'object' && !Array.isArray(data4)) {
                                        for (const key0 in data4) {
                                            let data5 = data4[key0];
                                            const _errs12 = errors;
                                            if (errors === _errs12) {
                                                if (Array.isArray(data5)) {
                                                    var valid3 = true;
                                                    const len1 = data5.length;
                                                    for (let i1 = 0; i1 < len1; i1++) {
                                                        let data6 = data5[i1];
                                                        const _errs14 = errors;
                                                        if (typeof data6 !== 'string') {
                                                            validate14.errors = [
                                                                {
                                                                    instancePath: instancePath +
                                                                        '/permissions/' +
                                                                        key0.replace(/~/g, '~0').replace(/\//g, '~1') +
                                                                        '/' +
                                                                        i1,
                                                                    schemaPath: '#/properties/permissions/additionalProperties/items/type',
                                                                    keyword: 'type',
                                                                    params: { type: 'string' },
                                                                    message: 'must be string'
                                                                }
                                                            ];
                                                            return false;
                                                        }
                                                        if (!(data6 === 'view' || data6 === 'edit' || data6 === 'run')) {
                                                            validate14.errors = [
                                                                {
                                                                    instancePath: instancePath +
                                                                        '/permissions/' +
                                                                        key0.replace(/~/g, '~0').replace(/\//g, '~1') +
                                                                        '/' +
                                                                        i1,
                                                                    schemaPath: '#/properties/permissions/additionalProperties/items/enum',
                                                                    keyword: 'enum',
                                                                    params: {
                                                                        allowedValues: schema31.properties.permissions.additionalProperties.items.enum
                                                                    },
                                                                    message: 'must be equal to one of the allowed values'
                                                                }
                                                            ];
                                                            return false;
                                                        }
                                                        var valid3 = _errs14 === errors;
                                                        if (!valid3) {
                                                            break;
                                                        }
                                                    }
                                                }
                                                else {
                                                    validate14.errors = [
                                                        {
                                                            instancePath: instancePath + '/permissions/' + key0.replace(/~/g, '~0').replace(/\//g, '~1'),
                                                            schemaPath: '#/properties/permissions/additionalProperties/type',
                                                            keyword: 'type',
                                                            params: { type: 'array' },
                                                            message: 'must be array'
                                                        }
                                                    ];
                                                    return false;
                                                }
                                            }
                                            var valid2 = _errs12 === errors;
                                            if (!valid2) {
                                                break;
                                            }
                                        }
                                    }
                                    else {
                                        validate14.errors = [
                                            {
                                                instancePath: instancePath + '/permissions',
                                                schemaPath: '#/properties/permissions/type',
                                                keyword: 'type',
                                                params: { type: 'object' },
                                                message: 'must be object'
                                            }
                                        ];
                                        return false;
                                    }
                                }
                                var valid0 = _errs9 === errors;
                            }
                            else {
                                var valid0 = true;
                            }
                        }
                    }
                }
            }
        }
        else {
            validate14.errors = [
                { instancePath, schemaPath: '#/type', keyword: 'type', params: { type: 'object' }, message: 'must be object' }
            ];
            return false;
        }
    }
    validate14.errors = vErrors;
    return errors === 0;
}
export const integrationEventQueueSchemaValidation = validate15;
const schema32 = {
    $id: 'urn:wisepipe-domain-authorize:IntegrationEventQueue',
    type: 'object',
    properties: {
        integrationSource: { type: 'string' },
        integrationType: { type: 'string', enum: ['incentives'] },
        integrationEventType: {
            type: 'string',
            enum: ['element', 'calculation', 'locking_calc', 'changeRequest', 'node_validation']
        },
        sqsQueueUrl: { type: 'string' },
        kinesisStreamArn: { type: 'string' },
        integrationQueueType: { type: 'string', enum: ['sqs', 'kinesis', 'sqs-dlq', 'sns'] },
        accessorRoleArn: { type: 'string' },
        snsTopicArn: { type: 'string' }
    },
    required: ['integrationSource', 'integrationType'],
    if: { required: ['integrationQueueType'] },
    then: {
        allOf: [
            { if: { properties: { integrationQueueType: { const: 'sqs' } } }, then: { required: ['sqsQueueUrl'] } },
            { if: { properties: { integrationQueueType: { const: 'kinesis' } } }, then: { required: ['kinesisStreamArn'] } },
            { if: { properties: { integrationQueueType: { const: 'sns' } } }, then: { required: ['snsTopicArn'] } }
        ]
    }
};
function validate15(data, { instancePath = '', parentData, parentDataProperty, rootData = data } = {}) {
    /*# sourceURL="urn:wisepipe-domain-authorize:IntegrationEventQueue" */ let vErrors = null;
    let errors = 0;
    const _errs1 = errors;
    let valid0 = true;
    const _errs2 = errors;
    if (data && typeof data == 'object' && !Array.isArray(data)) {
        let missing0;
        if (data.integrationQueueType === undefined && (missing0 = 'integrationQueueType')) {
            const err0 = {};
            if (vErrors === null) {
                vErrors = [err0];
            }
            else {
                vErrors.push(err0);
            }
            errors++;
        }
    }
    var _valid0 = _errs2 === errors;
    errors = _errs1;
    if (vErrors !== null) {
        if (_errs1) {
            vErrors.length = _errs1;
        }
        else {
            vErrors = null;
        }
    }
    if (_valid0) {
        const _errs3 = errors;
        const _errs4 = errors;
        const _errs5 = errors;
        let valid2 = true;
        const _errs6 = errors;
        if (data && typeof data == 'object' && !Array.isArray(data)) {
            if (data.integrationQueueType !== undefined) {
                if ('sqs' !== data.integrationQueueType) {
                    const err1 = {};
                    if (vErrors === null) {
                        vErrors = [err1];
                    }
                    else {
                        vErrors.push(err1);
                    }
                    errors++;
                }
            }
        }
        var _valid1 = _errs6 === errors;
        errors = _errs5;
        if (vErrors !== null) {
            if (_errs5) {
                vErrors.length = _errs5;
            }
            else {
                vErrors = null;
            }
        }
        if (_valid1) {
            const _errs8 = errors;
            if (data && typeof data == 'object' && !Array.isArray(data)) {
                let missing1;
                if (data.sqsQueueUrl === undefined && (missing1 = 'sqsQueueUrl')) {
                    validate15.errors = [
                        {
                            instancePath,
                            schemaPath: '#/then/allOf/0/then/required',
                            keyword: 'required',
                            params: { missingProperty: missing1 },
                            message: "must have required property '" + missing1 + "'"
                        }
                    ];
                    return false;
                }
            }
            var _valid1 = _errs8 === errors;
            valid2 = _valid1;
        }
        if (!valid2) {
            const err2 = {
                instancePath,
                schemaPath: '#/then/allOf/0/if',
                keyword: 'if',
                params: { failingKeyword: 'then' },
                message: 'must match "then" schema'
            };
            if (vErrors === null) {
                vErrors = [err2];
            }
            else {
                vErrors.push(err2);
            }
            errors++;
            validate15.errors = vErrors;
            return false;
        }
        var valid1 = _errs4 === errors;
        if (valid1) {
            const _errs9 = errors;
            const _errs10 = errors;
            let valid4 = true;
            const _errs11 = errors;
            if (data && typeof data == 'object' && !Array.isArray(data)) {
                if (data.integrationQueueType !== undefined) {
                    if ('kinesis' !== data.integrationQueueType) {
                        const err3 = {};
                        if (vErrors === null) {
                            vErrors = [err3];
                        }
                        else {
                            vErrors.push(err3);
                        }
                        errors++;
                    }
                }
            }
            var _valid2 = _errs11 === errors;
            errors = _errs10;
            if (vErrors !== null) {
                if (_errs10) {
                    vErrors.length = _errs10;
                }
                else {
                    vErrors = null;
                }
            }
            if (_valid2) {
                const _errs13 = errors;
                if (data && typeof data == 'object' && !Array.isArray(data)) {
                    let missing2;
                    if (data.kinesisStreamArn === undefined && (missing2 = 'kinesisStreamArn')) {
                        validate15.errors = [
                            {
                                instancePath,
                                schemaPath: '#/then/allOf/1/then/required',
                                keyword: 'required',
                                params: { missingProperty: missing2 },
                                message: "must have required property '" + missing2 + "'"
                            }
                        ];
                        return false;
                    }
                }
                var _valid2 = _errs13 === errors;
                valid4 = _valid2;
            }
            if (!valid4) {
                const err4 = {
                    instancePath,
                    schemaPath: '#/then/allOf/1/if',
                    keyword: 'if',
                    params: { failingKeyword: 'then' },
                    message: 'must match "then" schema'
                };
                if (vErrors === null) {
                    vErrors = [err4];
                }
                else {
                    vErrors.push(err4);
                }
                errors++;
                validate15.errors = vErrors;
                return false;
            }
            var valid1 = _errs9 === errors;
            if (valid1) {
                const _errs14 = errors;
                const _errs15 = errors;
                let valid6 = true;
                const _errs16 = errors;
                if (data && typeof data == 'object' && !Array.isArray(data)) {
                    if (data.integrationQueueType !== undefined) {
                        if ('sns' !== data.integrationQueueType) {
                            const err5 = {};
                            if (vErrors === null) {
                                vErrors = [err5];
                            }
                            else {
                                vErrors.push(err5);
                            }
                            errors++;
                        }
                    }
                }
                var _valid3 = _errs16 === errors;
                errors = _errs15;
                if (vErrors !== null) {
                    if (_errs15) {
                        vErrors.length = _errs15;
                    }
                    else {
                        vErrors = null;
                    }
                }
                if (_valid3) {
                    const _errs18 = errors;
                    if (data && typeof data == 'object' && !Array.isArray(data)) {
                        let missing3;
                        if (data.snsTopicArn === undefined && (missing3 = 'snsTopicArn')) {
                            validate15.errors = [
                                {
                                    instancePath,
                                    schemaPath: '#/then/allOf/2/then/required',
                                    keyword: 'required',
                                    params: { missingProperty: missing3 },
                                    message: "must have required property '" + missing3 + "'"
                                }
                            ];
                            return false;
                        }
                    }
                    var _valid3 = _errs18 === errors;
                    valid6 = _valid3;
                }
                if (!valid6) {
                    const err6 = {
                        instancePath,
                        schemaPath: '#/then/allOf/2/if',
                        keyword: 'if',
                        params: { failingKeyword: 'then' },
                        message: 'must match "then" schema'
                    };
                    if (vErrors === null) {
                        vErrors = [err6];
                    }
                    else {
                        vErrors.push(err6);
                    }
                    errors++;
                    validate15.errors = vErrors;
                    return false;
                }
                var valid1 = _errs14 === errors;
            }
        }
        var _valid0 = _errs3 === errors;
        valid0 = _valid0;
    }
    if (!valid0) {
        const err7 = {
            instancePath,
            schemaPath: '#/if',
            keyword: 'if',
            params: { failingKeyword: 'then' },
            message: 'must match "then" schema'
        };
        if (vErrors === null) {
            vErrors = [err7];
        }
        else {
            vErrors.push(err7);
        }
        errors++;
        validate15.errors = vErrors;
        return false;
    }
    if (errors === 0) {
        if (data && typeof data == 'object' && !Array.isArray(data)) {
            let missing4;
            if ((data.integrationSource === undefined && (missing4 = 'integrationSource')) ||
                (data.integrationType === undefined && (missing4 = 'integrationType'))) {
                validate15.errors = [
                    {
                        instancePath,
                        schemaPath: '#/required',
                        keyword: 'required',
                        params: { missingProperty: missing4 },
                        message: "must have required property '" + missing4 + "'"
                    }
                ];
                return false;
            }
            else {
                if (data.integrationSource !== undefined) {
                    const _errs19 = errors;
                    if (typeof data.integrationSource !== 'string') {
                        validate15.errors = [
                            {
                                instancePath: instancePath + '/integrationSource',
                                schemaPath: '#/properties/integrationSource/type',
                                keyword: 'type',
                                params: { type: 'string' },
                                message: 'must be string'
                            }
                        ];
                        return false;
                    }
                    var valid8 = _errs19 === errors;
                }
                else {
                    var valid8 = true;
                }
                if (valid8) {
                    if (data.integrationType !== undefined) {
                        let data4 = data.integrationType;
                        const _errs21 = errors;
                        if (typeof data4 !== 'string') {
                            validate15.errors = [
                                {
                                    instancePath: instancePath + '/integrationType',
                                    schemaPath: '#/properties/integrationType/type',
                                    keyword: 'type',
                                    params: { type: 'string' },
                                    message: 'must be string'
                                }
                            ];
                            return false;
                        }
                        if (!(data4 === 'incentives')) {
                            validate15.errors = [
                                {
                                    instancePath: instancePath + '/integrationType',
                                    schemaPath: '#/properties/integrationType/enum',
                                    keyword: 'enum',
                                    params: { allowedValues: schema32.properties.integrationType.enum },
                                    message: 'must be equal to one of the allowed values'
                                }
                            ];
                            return false;
                        }
                        var valid8 = _errs21 === errors;
                    }
                    else {
                        var valid8 = true;
                    }
                    if (valid8) {
                        if (data.integrationEventType !== undefined) {
                            let data5 = data.integrationEventType;
                            const _errs23 = errors;
                            if (typeof data5 !== 'string') {
                                validate15.errors = [
                                    {
                                        instancePath: instancePath + '/integrationEventType',
                                        schemaPath: '#/properties/integrationEventType/type',
                                        keyword: 'type',
                                        params: { type: 'string' },
                                        message: 'must be string'
                                    }
                                ];
                                return false;
                            }
                            if (!(data5 === 'element' ||
                                data5 === 'calculation' ||
                                data5 === 'locking_calc' ||
                                data5 === 'changeRequest' ||
                                data5 === 'node_validation')) {
                                validate15.errors = [
                                    {
                                        instancePath: instancePath + '/integrationEventType',
                                        schemaPath: '#/properties/integrationEventType/enum',
                                        keyword: 'enum',
                                        params: { allowedValues: schema32.properties.integrationEventType.enum },
                                        message: 'must be equal to one of the allowed values'
                                    }
                                ];
                                return false;
                            }
                            var valid8 = _errs23 === errors;
                        }
                        else {
                            var valid8 = true;
                        }
                        if (valid8) {
                            if (data.sqsQueueUrl !== undefined) {
                                const _errs25 = errors;
                                if (typeof data.sqsQueueUrl !== 'string') {
                                    validate15.errors = [
                                        {
                                            instancePath: instancePath + '/sqsQueueUrl',
                                            schemaPath: '#/properties/sqsQueueUrl/type',
                                            keyword: 'type',
                                            params: { type: 'string' },
                                            message: 'must be string'
                                        }
                                    ];
                                    return false;
                                }
                                var valid8 = _errs25 === errors;
                            }
                            else {
                                var valid8 = true;
                            }
                            if (valid8) {
                                if (data.kinesisStreamArn !== undefined) {
                                    const _errs27 = errors;
                                    if (typeof data.kinesisStreamArn !== 'string') {
                                        validate15.errors = [
                                            {
                                                instancePath: instancePath + '/kinesisStreamArn',
                                                schemaPath: '#/properties/kinesisStreamArn/type',
                                                keyword: 'type',
                                                params: { type: 'string' },
                                                message: 'must be string'
                                            }
                                        ];
                                        return false;
                                    }
                                    var valid8 = _errs27 === errors;
                                }
                                else {
                                    var valid8 = true;
                                }
                                if (valid8) {
                                    if (data.integrationQueueType !== undefined) {
                                        let data8 = data.integrationQueueType;
                                        const _errs29 = errors;
                                        if (typeof data8 !== 'string') {
                                            validate15.errors = [
                                                {
                                                    instancePath: instancePath + '/integrationQueueType',
                                                    schemaPath: '#/properties/integrationQueueType/type',
                                                    keyword: 'type',
                                                    params: { type: 'string' },
                                                    message: 'must be string'
                                                }
                                            ];
                                            return false;
                                        }
                                        if (!(data8 === 'sqs' || data8 === 'kinesis' || data8 === 'sqs-dlq' || data8 === 'sns')) {
                                            validate15.errors = [
                                                {
                                                    instancePath: instancePath + '/integrationQueueType',
                                                    schemaPath: '#/properties/integrationQueueType/enum',
                                                    keyword: 'enum',
                                                    params: { allowedValues: schema32.properties.integrationQueueType.enum },
                                                    message: 'must be equal to one of the allowed values'
                                                }
                                            ];
                                            return false;
                                        }
                                        var valid8 = _errs29 === errors;
                                    }
                                    else {
                                        var valid8 = true;
                                    }
                                    if (valid8) {
                                        if (data.accessorRoleArn !== undefined) {
                                            const _errs31 = errors;
                                            if (typeof data.accessorRoleArn !== 'string') {
                                                validate15.errors = [
                                                    {
                                                        instancePath: instancePath + '/accessorRoleArn',
                                                        schemaPath: '#/properties/accessorRoleArn/type',
                                                        keyword: 'type',
                                                        params: { type: 'string' },
                                                        message: 'must be string'
                                                    }
                                                ];
                                                return false;
                                            }
                                            var valid8 = _errs31 === errors;
                                        }
                                        else {
                                            var valid8 = true;
                                        }
                                        if (valid8) {
                                            if (data.snsTopicArn !== undefined) {
                                                const _errs33 = errors;
                                                if (typeof data.snsTopicArn !== 'string') {
                                                    validate15.errors = [
                                                        {
                                                            instancePath: instancePath + '/snsTopicArn',
                                                            schemaPath: '#/properties/snsTopicArn/type',
                                                            keyword: 'type',
                                                            params: { type: 'string' },
                                                            message: 'must be string'
                                                        }
                                                    ];
                                                    return false;
                                                }
                                                var valid8 = _errs33 === errors;
                                            }
                                            else {
                                                var valid8 = true;
                                            }
                                        }
                                    }
                                }
                            }
                        }
                    }
                }
            }
        }
        else {
            validate15.errors = [
                { instancePath, schemaPath: '#/type', keyword: 'type', params: { type: 'object' }, message: 'must be object' }
            ];
            return false;
        }
    }
    validate15.errors = vErrors;
    return errors === 0;
}
export const integrationOrgInfoSchemaValidation = validate16;
const schema33 = {
    $id: 'urn:wisepipe-domain-authorize:IntegrationOrgInfo',
    type: 'object',
    properties: {
        orgID: { type: 'string', format: 'uuid' },
        source: { type: 'string', minLength: 1 },
        sourceID: { type: 'string' },
        createdAt: { type: 'string', format: 'date-time' },
        integrationType: { type: 'string', enum: ['incentives'] },
        sqsQueueUrl: { type: 'string' },
        eventQueues: { type: 'array', items: { $ref: 'urn:wisepipe-domain-authorize:IntegrationEventQueue' } }
    },
    required: ['orgID', 'source', 'sourceID']
};
const formats8 = formatWrapper['date-time'];
function validate16(data, { instancePath = '', parentData, parentDataProperty, rootData = data } = {}) {
    /*# sourceURL="urn:wisepipe-domain-authorize:IntegrationOrgInfo" */ let vErrors = null;
    let errors = 0;
    if (errors === 0) {
        if (data && typeof data == 'object' && !Array.isArray(data)) {
            let missing0;
            if ((data.orgID === undefined && (missing0 = 'orgID')) ||
                (data.source === undefined && (missing0 = 'source')) ||
                (data.sourceID === undefined && (missing0 = 'sourceID'))) {
                validate16.errors = [
                    {
                        instancePath,
                        schemaPath: '#/required',
                        keyword: 'required',
                        params: { missingProperty: missing0 },
                        message: "must have required property '" + missing0 + "'"
                    }
                ];
                return false;
            }
            else {
                if (data.orgID !== undefined) {
                    let data0 = data.orgID;
                    const _errs1 = errors;
                    if (errors === _errs1) {
                        if (errors === _errs1) {
                            if (typeof data0 === 'string') {
                                if (!formats0.test(data0)) {
                                    validate16.errors = [
                                        {
                                            instancePath: instancePath + '/orgID',
                                            schemaPath: '#/properties/orgID/format',
                                            keyword: 'format',
                                            params: { format: 'uuid' },
                                            message: 'must match format "' + 'uuid' + '"'
                                        }
                                    ];
                                    return false;
                                }
                            }
                            else {
                                validate16.errors = [
                                    {
                                        instancePath: instancePath + '/orgID',
                                        schemaPath: '#/properties/orgID/type',
                                        keyword: 'type',
                                        params: { type: 'string' },
                                        message: 'must be string'
                                    }
                                ];
                                return false;
                            }
                        }
                    }
                    var valid0 = _errs1 === errors;
                }
                else {
                    var valid0 = true;
                }
                if (valid0) {
                    if (data.source !== undefined) {
                        let data1 = data.source;
                        const _errs3 = errors;
                        if (errors === _errs3) {
                            if (typeof data1 === 'string') {
                                if (func2(data1) < 1) {
                                    validate16.errors = [
                                        {
                                            instancePath: instancePath + '/source',
                                            schemaPath: '#/properties/source/minLength',
                                            keyword: 'minLength',
                                            params: { limit: 1 },
                                            message: 'must NOT have fewer than 1 characters'
                                        }
                                    ];
                                    return false;
                                }
                            }
                            else {
                                validate16.errors = [
                                    {
                                        instancePath: instancePath + '/source',
                                        schemaPath: '#/properties/source/type',
                                        keyword: 'type',
                                        params: { type: 'string' },
                                        message: 'must be string'
                                    }
                                ];
                                return false;
                            }
                        }
                        var valid0 = _errs3 === errors;
                    }
                    else {
                        var valid0 = true;
                    }
                    if (valid0) {
                        if (data.sourceID !== undefined) {
                            const _errs5 = errors;
                            if (typeof data.sourceID !== 'string') {
                                validate16.errors = [
                                    {
                                        instancePath: instancePath + '/sourceID',
                                        schemaPath: '#/properties/sourceID/type',
                                        keyword: 'type',
                                        params: { type: 'string' },
                                        message: 'must be string'
                                    }
                                ];
                                return false;
                            }
                            var valid0 = _errs5 === errors;
                        }
                        else {
                            var valid0 = true;
                        }
                        if (valid0) {
                            if (data.createdAt !== undefined) {
                                let data3 = data.createdAt;
                                const _errs7 = errors;
                                if (errors === _errs7) {
                                    if (errors === _errs7) {
                                        if (typeof data3 === 'string') {
                                            if (!formats8.validate(data3)) {
                                                validate16.errors = [
                                                    {
                                                        instancePath: instancePath + '/createdAt',
                                                        schemaPath: '#/properties/createdAt/format',
                                                        keyword: 'format',
                                                        params: { format: 'date-time' },
                                                        message: 'must match format "' + 'date-time' + '"'
                                                    }
                                                ];
                                                return false;
                                            }
                                        }
                                        else {
                                            validate16.errors = [
                                                {
                                                    instancePath: instancePath + '/createdAt',
                                                    schemaPath: '#/properties/createdAt/type',
                                                    keyword: 'type',
                                                    params: { type: 'string' },
                                                    message: 'must be string'
                                                }
                                            ];
                                            return false;
                                        }
                                    }
                                }
                                var valid0 = _errs7 === errors;
                            }
                            else {
                                var valid0 = true;
                            }
                            if (valid0) {
                                if (data.integrationType !== undefined) {
                                    let data4 = data.integrationType;
                                    const _errs9 = errors;
                                    if (typeof data4 !== 'string') {
                                        validate16.errors = [
                                            {
                                                instancePath: instancePath + '/integrationType',
                                                schemaPath: '#/properties/integrationType/type',
                                                keyword: 'type',
                                                params: { type: 'string' },
                                                message: 'must be string'
                                            }
                                        ];
                                        return false;
                                    }
                                    if (!(data4 === 'incentives')) {
                                        validate16.errors = [
                                            {
                                                instancePath: instancePath + '/integrationType',
                                                schemaPath: '#/properties/integrationType/enum',
                                                keyword: 'enum',
                                                params: { allowedValues: schema33.properties.integrationType.enum },
                                                message: 'must be equal to one of the allowed values'
                                            }
                                        ];
                                        return false;
                                    }
                                    var valid0 = _errs9 === errors;
                                }
                                else {
                                    var valid0 = true;
                                }
                                if (valid0) {
                                    if (data.sqsQueueUrl !== undefined) {
                                        const _errs11 = errors;
                                        if (typeof data.sqsQueueUrl !== 'string') {
                                            validate16.errors = [
                                                {
                                                    instancePath: instancePath + '/sqsQueueUrl',
                                                    schemaPath: '#/properties/sqsQueueUrl/type',
                                                    keyword: 'type',
                                                    params: { type: 'string' },
                                                    message: 'must be string'
                                                }
                                            ];
                                            return false;
                                        }
                                        var valid0 = _errs11 === errors;
                                    }
                                    else {
                                        var valid0 = true;
                                    }
                                    if (valid0) {
                                        if (data.eventQueues !== undefined) {
                                            let data6 = data.eventQueues;
                                            const _errs13 = errors;
                                            if (errors === _errs13) {
                                                if (Array.isArray(data6)) {
                                                    var valid1 = true;
                                                    const len0 = data6.length;
                                                    for (let i0 = 0; i0 < len0; i0++) {
                                                        let data7 = data6[i0];
                                                        const _errs15 = errors;
                                                        const _errs16 = errors;
                                                        const _errs18 = errors;
                                                        let valid3 = true;
                                                        const _errs19 = errors;
                                                        if (data7 && typeof data7 == 'object' && !Array.isArray(data7)) {
                                                            let missing1;
                                                            if (data7.integrationQueueType === undefined && (missing1 = 'integrationQueueType')) {
                                                                const err0 = {};
                                                                if (vErrors === null) {
                                                                    vErrors = [err0];
                                                                }
                                                                else {
                                                                    vErrors.push(err0);
                                                                }
                                                                errors++;
                                                            }
                                                        }
                                                        var _valid0 = _errs19 === errors;
                                                        errors = _errs18;
                                                        if (vErrors !== null) {
                                                            if (_errs18) {
                                                                vErrors.length = _errs18;
                                                            }
                                                            else {
                                                                vErrors = null;
                                                            }
                                                        }
                                                        if (_valid0) {
                                                            const _errs20 = errors;
                                                            const _errs21 = errors;
                                                            const _errs22 = errors;
                                                            let valid5 = true;
                                                            const _errs23 = errors;
                                                            if (data7 && typeof data7 == 'object' && !Array.isArray(data7)) {
                                                                if (data7.integrationQueueType !== undefined) {
                                                                    if ('sqs' !== data7.integrationQueueType) {
                                                                        const err1 = {};
                                                                        if (vErrors === null) {
                                                                            vErrors = [err1];
                                                                        }
                                                                        else {
                                                                            vErrors.push(err1);
                                                                        }
                                                                        errors++;
                                                                    }
                                                                }
                                                            }
                                                            var _valid1 = _errs23 === errors;
                                                            errors = _errs22;
                                                            if (vErrors !== null) {
                                                                if (_errs22) {
                                                                    vErrors.length = _errs22;
                                                                }
                                                                else {
                                                                    vErrors = null;
                                                                }
                                                            }
                                                            if (_valid1) {
                                                                const _errs25 = errors;
                                                                if (data7 && typeof data7 == 'object' && !Array.isArray(data7)) {
                                                                    let missing2;
                                                                    if (data7.sqsQueueUrl === undefined && (missing2 = 'sqsQueueUrl')) {
                                                                        validate16.errors = [
                                                                            {
                                                                                instancePath: instancePath + '/eventQueues/' + i0,
                                                                                schemaPath: 'urn:wisepipe-domain-authorize:IntegrationEventQueue/then/allOf/0/then/required',
                                                                                keyword: 'required',
                                                                                params: { missingProperty: missing2 },
                                                                                message: "must have required property '" + missing2 + "'"
                                                                            }
                                                                        ];
                                                                        return false;
                                                                    }
                                                                }
                                                                var _valid1 = _errs25 === errors;
                                                                valid5 = _valid1;
                                                            }
                                                            if (!valid5) {
                                                                const err2 = {
                                                                    instancePath: instancePath + '/eventQueues/' + i0,
                                                                    schemaPath: 'urn:wisepipe-domain-authorize:IntegrationEventQueue/then/allOf/0/if',
                                                                    keyword: 'if',
                                                                    params: { failingKeyword: 'then' },
                                                                    message: 'must match "then" schema'
                                                                };
                                                                if (vErrors === null) {
                                                                    vErrors = [err2];
                                                                }
                                                                else {
                                                                    vErrors.push(err2);
                                                                }
                                                                errors++;
                                                                validate16.errors = vErrors;
                                                                return false;
                                                            }
                                                            var valid4 = _errs21 === errors;
                                                            if (valid4) {
                                                                const _errs26 = errors;
                                                                const _errs27 = errors;
                                                                let valid7 = true;
                                                                const _errs28 = errors;
                                                                if (data7 && typeof data7 == 'object' && !Array.isArray(data7)) {
                                                                    if (data7.integrationQueueType !== undefined) {
                                                                        if ('kinesis' !== data7.integrationQueueType) {
                                                                            const err3 = {};
                                                                            if (vErrors === null) {
                                                                                vErrors = [err3];
                                                                            }
                                                                            else {
                                                                                vErrors.push(err3);
                                                                            }
                                                                            errors++;
                                                                        }
                                                                    }
                                                                }
                                                                var _valid2 = _errs28 === errors;
                                                                errors = _errs27;
                                                                if (vErrors !== null) {
                                                                    if (_errs27) {
                                                                        vErrors.length = _errs27;
                                                                    }
                                                                    else {
                                                                        vErrors = null;
                                                                    }
                                                                }
                                                                if (_valid2) {
                                                                    const _errs30 = errors;
                                                                    if (data7 && typeof data7 == 'object' && !Array.isArray(data7)) {
                                                                        let missing3;
                                                                        if (data7.kinesisStreamArn === undefined && (missing3 = 'kinesisStreamArn')) {
                                                                            validate16.errors = [
                                                                                {
                                                                                    instancePath: instancePath + '/eventQueues/' + i0,
                                                                                    schemaPath: 'urn:wisepipe-domain-authorize:IntegrationEventQueue/then/allOf/1/then/required',
                                                                                    keyword: 'required',
                                                                                    params: { missingProperty: missing3 },
                                                                                    message: "must have required property '" + missing3 + "'"
                                                                                }
                                                                            ];
                                                                            return false;
                                                                        }
                                                                    }
                                                                    var _valid2 = _errs30 === errors;
                                                                    valid7 = _valid2;
                                                                }
                                                                if (!valid7) {
                                                                    const err4 = {
                                                                        instancePath: instancePath + '/eventQueues/' + i0,
                                                                        schemaPath: 'urn:wisepipe-domain-authorize:IntegrationEventQueue/then/allOf/1/if',
                                                                        keyword: 'if',
                                                                        params: { failingKeyword: 'then' },
                                                                        message: 'must match "then" schema'
                                                                    };
                                                                    if (vErrors === null) {
                                                                        vErrors = [err4];
                                                                    }
                                                                    else {
                                                                        vErrors.push(err4);
                                                                    }
                                                                    errors++;
                                                                    validate16.errors = vErrors;
                                                                    return false;
                                                                }
                                                                var valid4 = _errs26 === errors;
                                                                if (valid4) {
                                                                    const _errs31 = errors;
                                                                    const _errs32 = errors;
                                                                    let valid9 = true;
                                                                    const _errs33 = errors;
                                                                    if (data7 && typeof data7 == 'object' && !Array.isArray(data7)) {
                                                                        if (data7.integrationQueueType !== undefined) {
                                                                            if ('sns' !== data7.integrationQueueType) {
                                                                                const err5 = {};
                                                                                if (vErrors === null) {
                                                                                    vErrors = [err5];
                                                                                }
                                                                                else {
                                                                                    vErrors.push(err5);
                                                                                }
                                                                                errors++;
                                                                            }
                                                                        }
                                                                    }
                                                                    var _valid3 = _errs33 === errors;
                                                                    errors = _errs32;
                                                                    if (vErrors !== null) {
                                                                        if (_errs32) {
                                                                            vErrors.length = _errs32;
                                                                        }
                                                                        else {
                                                                            vErrors = null;
                                                                        }
                                                                    }
                                                                    if (_valid3) {
                                                                        const _errs35 = errors;
                                                                        if (data7 && typeof data7 == 'object' && !Array.isArray(data7)) {
                                                                            let missing4;
                                                                            if (data7.snsTopicArn === undefined && (missing4 = 'snsTopicArn')) {
                                                                                validate16.errors = [
                                                                                    {
                                                                                        instancePath: instancePath + '/eventQueues/' + i0,
                                                                                        schemaPath: 'urn:wisepipe-domain-authorize:IntegrationEventQueue/then/allOf/2/then/required',
                                                                                        keyword: 'required',
                                                                                        params: { missingProperty: missing4 },
                                                                                        message: "must have required property '" + missing4 + "'"
                                                                                    }
                                                                                ];
                                                                                return false;
                                                                            }
                                                                        }
                                                                        var _valid3 = _errs35 === errors;
                                                                        valid9 = _valid3;
                                                                    }
                                                                    if (!valid9) {
                                                                        const err6 = {
                                                                            instancePath: instancePath + '/eventQueues/' + i0,
                                                                            schemaPath: 'urn:wisepipe-domain-authorize:IntegrationEventQueue/then/allOf/2/if',
                                                                            keyword: 'if',
                                                                            params: { failingKeyword: 'then' },
                                                                            message: 'must match "then" schema'
                                                                        };
                                                                        if (vErrors === null) {
                                                                            vErrors = [err6];
                                                                        }
                                                                        else {
                                                                            vErrors.push(err6);
                                                                        }
                                                                        errors++;
                                                                        validate16.errors = vErrors;
                                                                        return false;
                                                                    }
                                                                    var valid4 = _errs31 === errors;
                                                                }
                                                            }
                                                            var _valid0 = _errs20 === errors;
                                                            valid3 = _valid0;
                                                        }
                                                        if (!valid3) {
                                                            const err7 = {
                                                                instancePath: instancePath + '/eventQueues/' + i0,
                                                                schemaPath: 'urn:wisepipe-domain-authorize:IntegrationEventQueue/if',
                                                                keyword: 'if',
                                                                params: { failingKeyword: 'then' },
                                                                message: 'must match "then" schema'
                                                            };
                                                            if (vErrors === null) {
                                                                vErrors = [err7];
                                                            }
                                                            else {
                                                                vErrors.push(err7);
                                                            }
                                                            errors++;
                                                            validate16.errors = vErrors;
                                                            return false;
                                                        }
                                                        if (errors === _errs16) {
                                                            if (data7 && typeof data7 == 'object' && !Array.isArray(data7)) {
                                                                let missing5;
                                                                if ((data7.integrationSource === undefined && (missing5 = 'integrationSource')) ||
                                                                    (data7.integrationType === undefined && (missing5 = 'integrationType'))) {
                                                                    validate16.errors = [
                                                                        {
                                                                            instancePath: instancePath + '/eventQueues/' + i0,
                                                                            schemaPath: 'urn:wisepipe-domain-authorize:IntegrationEventQueue/required',
                                                                            keyword: 'required',
                                                                            params: { missingProperty: missing5 },
                                                                            message: "must have required property '" + missing5 + "'"
                                                                        }
                                                                    ];
                                                                    return false;
                                                                }
                                                                else {
                                                                    if (data7.integrationSource !== undefined) {
                                                                        const _errs36 = errors;
                                                                        if (typeof data7.integrationSource !== 'string') {
                                                                            validate16.errors = [
                                                                                {
                                                                                    instancePath: instancePath + '/eventQueues/' + i0 + '/integrationSource',
                                                                                    schemaPath: 'urn:wisepipe-domain-authorize:IntegrationEventQueue/properties/integrationSource/type',
                                                                                    keyword: 'type',
                                                                                    params: { type: 'string' },
                                                                                    message: 'must be string'
                                                                                }
                                                                            ];
                                                                            return false;
                                                                        }
                                                                        var valid11 = _errs36 === errors;
                                                                    }
                                                                    else {
                                                                        var valid11 = true;
                                                                    }
                                                                    if (valid11) {
                                                                        if (data7.integrationType !== undefined) {
                                                                            let data12 = data7.integrationType;
                                                                            const _errs38 = errors;
                                                                            if (typeof data12 !== 'string') {
                                                                                validate16.errors = [
                                                                                    {
                                                                                        instancePath: instancePath + '/eventQueues/' + i0 + '/integrationType',
                                                                                        schemaPath: 'urn:wisepipe-domain-authorize:IntegrationEventQueue/properties/integrationType/type',
                                                                                        keyword: 'type',
                                                                                        params: { type: 'string' },
                                                                                        message: 'must be string'
                                                                                    }
                                                                                ];
                                                                                return false;
                                                                            }
                                                                            if (!(data12 === 'incentives')) {
                                                                                validate16.errors = [
                                                                                    {
                                                                                        instancePath: instancePath + '/eventQueues/' + i0 + '/integrationType',
                                                                                        schemaPath: 'urn:wisepipe-domain-authorize:IntegrationEventQueue/properties/integrationType/enum',
                                                                                        keyword: 'enum',
                                                                                        params: { allowedValues: schema32.properties.integrationType.enum },
                                                                                        message: 'must be equal to one of the allowed values'
                                                                                    }
                                                                                ];
                                                                                return false;
                                                                            }
                                                                            var valid11 = _errs38 === errors;
                                                                        }
                                                                        else {
                                                                            var valid11 = true;
                                                                        }
                                                                        if (valid11) {
                                                                            if (data7.integrationEventType !== undefined) {
                                                                                let data13 = data7.integrationEventType;
                                                                                const _errs40 = errors;
                                                                                if (typeof data13 !== 'string') {
                                                                                    validate16.errors = [
                                                                                        {
                                                                                            instancePath: instancePath + '/eventQueues/' + i0 + '/integrationEventType',
                                                                                            schemaPath: 'urn:wisepipe-domain-authorize:IntegrationEventQueue/properties/integrationEventType/type',
                                                                                            keyword: 'type',
                                                                                            params: { type: 'string' },
                                                                                            message: 'must be string'
                                                                                        }
                                                                                    ];
                                                                                    return false;
                                                                                }
                                                                                if (!(data13 === 'element' ||
                                                                                    data13 === 'calculation' ||
                                                                                    data13 === 'locking_calc' ||
                                                                                    data13 === 'changeRequest' ||
                                                                                    data13 === 'node_validation')) {
                                                                                    validate16.errors = [
                                                                                        {
                                                                                            instancePath: instancePath + '/eventQueues/' + i0 + '/integrationEventType',
                                                                                            schemaPath: 'urn:wisepipe-domain-authorize:IntegrationEventQueue/properties/integrationEventType/enum',
                                                                                            keyword: 'enum',
                                                                                            params: { allowedValues: schema32.properties.integrationEventType.enum },
                                                                                            message: 'must be equal to one of the allowed values'
                                                                                        }
                                                                                    ];
                                                                                    return false;
                                                                                }
                                                                                var valid11 = _errs40 === errors;
                                                                            }
                                                                            else {
                                                                                var valid11 = true;
                                                                            }
                                                                            if (valid11) {
                                                                                if (data7.sqsQueueUrl !== undefined) {
                                                                                    const _errs42 = errors;
                                                                                    if (typeof data7.sqsQueueUrl !== 'string') {
                                                                                        validate16.errors = [
                                                                                            {
                                                                                                instancePath: instancePath + '/eventQueues/' + i0 + '/sqsQueueUrl',
                                                                                                schemaPath: 'urn:wisepipe-domain-authorize:IntegrationEventQueue/properties/sqsQueueUrl/type',
                                                                                                keyword: 'type',
                                                                                                params: { type: 'string' },
                                                                                                message: 'must be string'
                                                                                            }
                                                                                        ];
                                                                                        return false;
                                                                                    }
                                                                                    var valid11 = _errs42 === errors;
                                                                                }
                                                                                else {
                                                                                    var valid11 = true;
                                                                                }
                                                                                if (valid11) {
                                                                                    if (data7.kinesisStreamArn !== undefined) {
                                                                                        const _errs44 = errors;
                                                                                        if (typeof data7.kinesisStreamArn !== 'string') {
                                                                                            validate16.errors = [
                                                                                                {
                                                                                                    instancePath: instancePath + '/eventQueues/' + i0 + '/kinesisStreamArn',
                                                                                                    schemaPath: 'urn:wisepipe-domain-authorize:IntegrationEventQueue/properties/kinesisStreamArn/type',
                                                                                                    keyword: 'type',
                                                                                                    params: { type: 'string' },
                                                                                                    message: 'must be string'
                                                                                                }
                                                                                            ];
                                                                                            return false;
                                                                                        }
                                                                                        var valid11 = _errs44 === errors;
                                                                                    }
                                                                                    else {
                                                                                        var valid11 = true;
                                                                                    }
                                                                                    if (valid11) {
                                                                                        if (data7.integrationQueueType !== undefined) {
                                                                                            let data16 = data7.integrationQueueType;
                                                                                            const _errs46 = errors;
                                                                                            if (typeof data16 !== 'string') {
                                                                                                validate16.errors = [
                                                                                                    {
                                                                                                        instancePath: instancePath + '/eventQueues/' + i0 + '/integrationQueueType',
                                                                                                        schemaPath: 'urn:wisepipe-domain-authorize:IntegrationEventQueue/properties/integrationQueueType/type',
                                                                                                        keyword: 'type',
                                                                                                        params: { type: 'string' },
                                                                                                        message: 'must be string'
                                                                                                    }
                                                                                                ];
                                                                                                return false;
                                                                                            }
                                                                                            if (!(data16 === 'sqs' ||
                                                                                                data16 === 'kinesis' ||
                                                                                                data16 === 'sqs-dlq' ||
                                                                                                data16 === 'sns')) {
                                                                                                validate16.errors = [
                                                                                                    {
                                                                                                        instancePath: instancePath + '/eventQueues/' + i0 + '/integrationQueueType',
                                                                                                        schemaPath: 'urn:wisepipe-domain-authorize:IntegrationEventQueue/properties/integrationQueueType/enum',
                                                                                                        keyword: 'enum',
                                                                                                        params: {
                                                                                                            allowedValues: schema32.properties.integrationQueueType.enum
                                                                                                        },
                                                                                                        message: 'must be equal to one of the allowed values'
                                                                                                    }
                                                                                                ];
                                                                                                return false;
                                                                                            }
                                                                                            var valid11 = _errs46 === errors;
                                                                                        }
                                                                                        else {
                                                                                            var valid11 = true;
                                                                                        }
                                                                                        if (valid11) {
                                                                                            if (data7.accessorRoleArn !== undefined) {
                                                                                                const _errs48 = errors;
                                                                                                if (typeof data7.accessorRoleArn !== 'string') {
                                                                                                    validate16.errors = [
                                                                                                        {
                                                                                                            instancePath: instancePath + '/eventQueues/' + i0 + '/accessorRoleArn',
                                                                                                            schemaPath: 'urn:wisepipe-domain-authorize:IntegrationEventQueue/properties/accessorRoleArn/type',
                                                                                                            keyword: 'type',
                                                                                                            params: { type: 'string' },
                                                                                                            message: 'must be string'
                                                                                                        }
                                                                                                    ];
                                                                                                    return false;
                                                                                                }
                                                                                                var valid11 = _errs48 === errors;
                                                                                            }
                                                                                            else {
                                                                                                var valid11 = true;
                                                                                            }
                                                                                            if (valid11) {
                                                                                                if (data7.snsTopicArn !== undefined) {
                                                                                                    const _errs50 = errors;
                                                                                                    if (typeof data7.snsTopicArn !== 'string') {
                                                                                                        validate16.errors = [
                                                                                                            {
                                                                                                                instancePath: instancePath + '/eventQueues/' + i0 + '/snsTopicArn',
                                                                                                                schemaPath: 'urn:wisepipe-domain-authorize:IntegrationEventQueue/properties/snsTopicArn/type',
                                                                                                                keyword: 'type',
                                                                                                                params: { type: 'string' },
                                                                                                                message: 'must be string'
                                                                                                            }
                                                                                                        ];
                                                                                                        return false;
                                                                                                    }
                                                                                                    var valid11 = _errs50 === errors;
                                                                                                }
                                                                                                else {
                                                                                                    var valid11 = true;
                                                                                                }
                                                                                            }
                                                                                        }
                                                                                    }
                                                                                }
                                                                            }
                                                                        }
                                                                    }
                                                                }
                                                            }
                                                            else {
                                                                validate16.errors = [
                                                                    {
                                                                        instancePath: instancePath + '/eventQueues/' + i0,
                                                                        schemaPath: 'urn:wisepipe-domain-authorize:IntegrationEventQueue/type',
                                                                        keyword: 'type',
                                                                        params: { type: 'object' },
                                                                        message: 'must be object'
                                                                    }
                                                                ];
                                                                return false;
                                                            }
                                                        }
                                                        var valid1 = _errs15 === errors;
                                                        if (!valid1) {
                                                            break;
                                                        }
                                                    }
                                                }
                                                else {
                                                    validate16.errors = [
                                                        {
                                                            instancePath: instancePath + '/eventQueues',
                                                            schemaPath: '#/properties/eventQueues/type',
                                                            keyword: 'type',
                                                            params: { type: 'array' },
                                                            message: 'must be array'
                                                        }
                                                    ];
                                                    return false;
                                                }
                                            }
                                            var valid0 = _errs13 === errors;
                                        }
                                        else {
                                            var valid0 = true;
                                        }
                                    }
                                }
                            }
                        }
                    }
                }
            }
        }
        else {
            validate16.errors = [
                { instancePath, schemaPath: '#/type', keyword: 'type', params: { type: 'object' }, message: 'must be object' }
            ];
            return false;
        }
    }
    validate16.errors = vErrors;
    return errors === 0;
}
export const integrationUserSchemaValidation = validate17;
const schema35 = {
    $id: 'urn:wisepipe-domain-authorize:IntegrationUser',
    type: 'object',
    properties: {
        id: { type: 'number' },
        email: { type: 'string' },
        clientName: { type: 'string', minLength: 1 },
        userID: { type: 'string', format: 'uuid' },
        sourceUserID: { type: 'string', minLength: 1 },
        orgID: { type: 'string', format: 'uuid' }
    },
    required: ['id', 'email', 'clientName', 'userID', 'sourceUserID']
};
function validate17(data, { instancePath = '', parentData, parentDataProperty, rootData = data } = {}) {
    /*# sourceURL="urn:wisepipe-domain-authorize:IntegrationUser" */ let vErrors = null;
    let errors = 0;
    if (errors === 0) {
        if (data && typeof data == 'object' && !Array.isArray(data)) {
            let missing0;
            if ((data.id === undefined && (missing0 = 'id')) ||
                (data.email === undefined && (missing0 = 'email')) ||
                (data.clientName === undefined && (missing0 = 'clientName')) ||
                (data.userID === undefined && (missing0 = 'userID')) ||
                (data.sourceUserID === undefined && (missing0 = 'sourceUserID'))) {
                validate17.errors = [
                    {
                        instancePath,
                        schemaPath: '#/required',
                        keyword: 'required',
                        params: { missingProperty: missing0 },
                        message: "must have required property '" + missing0 + "'"
                    }
                ];
                return false;
            }
            else {
                if (data.id !== undefined) {
                    const _errs1 = errors;
                    if (!(typeof data.id == 'number')) {
                        validate17.errors = [
                            {
                                instancePath: instancePath + '/id',
                                schemaPath: '#/properties/id/type',
                                keyword: 'type',
                                params: { type: 'number' },
                                message: 'must be number'
                            }
                        ];
                        return false;
                    }
                    var valid0 = _errs1 === errors;
                }
                else {
                    var valid0 = true;
                }
                if (valid0) {
                    if (data.email !== undefined) {
                        const _errs3 = errors;
                        if (typeof data.email !== 'string') {
                            validate17.errors = [
                                {
                                    instancePath: instancePath + '/email',
                                    schemaPath: '#/properties/email/type',
                                    keyword: 'type',
                                    params: { type: 'string' },
                                    message: 'must be string'
                                }
                            ];
                            return false;
                        }
                        var valid0 = _errs3 === errors;
                    }
                    else {
                        var valid0 = true;
                    }
                    if (valid0) {
                        if (data.clientName !== undefined) {
                            let data2 = data.clientName;
                            const _errs5 = errors;
                            if (errors === _errs5) {
                                if (typeof data2 === 'string') {
                                    if (func2(data2) < 1) {
                                        validate17.errors = [
                                            {
                                                instancePath: instancePath + '/clientName',
                                                schemaPath: '#/properties/clientName/minLength',
                                                keyword: 'minLength',
                                                params: { limit: 1 },
                                                message: 'must NOT have fewer than 1 characters'
                                            }
                                        ];
                                        return false;
                                    }
                                }
                                else {
                                    validate17.errors = [
                                        {
                                            instancePath: instancePath + '/clientName',
                                            schemaPath: '#/properties/clientName/type',
                                            keyword: 'type',
                                            params: { type: 'string' },
                                            message: 'must be string'
                                        }
                                    ];
                                    return false;
                                }
                            }
                            var valid0 = _errs5 === errors;
                        }
                        else {
                            var valid0 = true;
                        }
                        if (valid0) {
                            if (data.userID !== undefined) {
                                let data3 = data.userID;
                                const _errs7 = errors;
                                if (errors === _errs7) {
                                    if (errors === _errs7) {
                                        if (typeof data3 === 'string') {
                                            if (!formats0.test(data3)) {
                                                validate17.errors = [
                                                    {
                                                        instancePath: instancePath + '/userID',
                                                        schemaPath: '#/properties/userID/format',
                                                        keyword: 'format',
                                                        params: { format: 'uuid' },
                                                        message: 'must match format "' + 'uuid' + '"'
                                                    }
                                                ];
                                                return false;
                                            }
                                        }
                                        else {
                                            validate17.errors = [
                                                {
                                                    instancePath: instancePath + '/userID',
                                                    schemaPath: '#/properties/userID/type',
                                                    keyword: 'type',
                                                    params: { type: 'string' },
                                                    message: 'must be string'
                                                }
                                            ];
                                            return false;
                                        }
                                    }
                                }
                                var valid0 = _errs7 === errors;
                            }
                            else {
                                var valid0 = true;
                            }
                            if (valid0) {
                                if (data.sourceUserID !== undefined) {
                                    let data4 = data.sourceUserID;
                                    const _errs9 = errors;
                                    if (errors === _errs9) {
                                        if (typeof data4 === 'string') {
                                            if (func2(data4) < 1) {
                                                validate17.errors = [
                                                    {
                                                        instancePath: instancePath + '/sourceUserID',
                                                        schemaPath: '#/properties/sourceUserID/minLength',
                                                        keyword: 'minLength',
                                                        params: { limit: 1 },
                                                        message: 'must NOT have fewer than 1 characters'
                                                    }
                                                ];
                                                return false;
                                            }
                                        }
                                        else {
                                            validate17.errors = [
                                                {
                                                    instancePath: instancePath + '/sourceUserID',
                                                    schemaPath: '#/properties/sourceUserID/type',
                                                    keyword: 'type',
                                                    params: { type: 'string' },
                                                    message: 'must be string'
                                                }
                                            ];
                                            return false;
                                        }
                                    }
                                    var valid0 = _errs9 === errors;
                                }
                                else {
                                    var valid0 = true;
                                }
                                if (valid0) {
                                    if (data.orgID !== undefined) {
                                        let data5 = data.orgID;
                                        const _errs11 = errors;
                                        if (errors === _errs11) {
                                            if (errors === _errs11) {
                                                if (typeof data5 === 'string') {
                                                    if (!formats0.test(data5)) {
                                                        validate17.errors = [
                                                            {
                                                                instancePath: instancePath + '/orgID',
                                                                schemaPath: '#/properties/orgID/format',
                                                                keyword: 'format',
                                                                params: { format: 'uuid' },
                                                                message: 'must match format "' + 'uuid' + '"'
                                                            }
                                                        ];
                                                        return false;
                                                    }
                                                }
                                                else {
                                                    validate17.errors = [
                                                        {
                                                            instancePath: instancePath + '/orgID',
                                                            schemaPath: '#/properties/orgID/type',
                                                            keyword: 'type',
                                                            params: { type: 'string' },
                                                            message: 'must be string'
                                                        }
                                                    ];
                                                    return false;
                                                }
                                            }
                                        }
                                        var valid0 = _errs11 === errors;
                                    }
                                    else {
                                        var valid0 = true;
                                    }
                                }
                            }
                        }
                    }
                }
            }
        }
        else {
            validate17.errors = [
                { instancePath, schemaPath: '#/type', keyword: 'type', params: { type: 'object' }, message: 'must be object' }
            ];
            return false;
        }
    }
    validate17.errors = vErrors;
    return errors === 0;
}
export const orgCreditSchemaValidation = validate18;
const schema36 = {
    $id: 'urn:wisepipe-domain-authorize:OrgCredit',
    type: 'object',
    properties: {
        id: { type: 'string', format: 'uuid' },
        monthlyCredit: { type: 'number' },
        orgName: { type: 'string', minLength: 1, maxLength: 100 }
    },
    required: ['id', 'monthlyCredit', 'orgName']
};
function validate18(data, { instancePath = '', parentData, parentDataProperty, rootData = data } = {}) {
    /*# sourceURL="urn:wisepipe-domain-authorize:OrgCredit" */ let vErrors = null;
    let errors = 0;
    if (errors === 0) {
        if (data && typeof data == 'object' && !Array.isArray(data)) {
            let missing0;
            if ((data.id === undefined && (missing0 = 'id')) ||
                (data.monthlyCredit === undefined && (missing0 = 'monthlyCredit')) ||
                (data.orgName === undefined && (missing0 = 'orgName'))) {
                validate18.errors = [
                    {
                        instancePath,
                        schemaPath: '#/required',
                        keyword: 'required',
                        params: { missingProperty: missing0 },
                        message: "must have required property '" + missing0 + "'"
                    }
                ];
                return false;
            }
            else {
                if (data.id !== undefined) {
                    let data0 = data.id;
                    const _errs1 = errors;
                    if (errors === _errs1) {
                        if (errors === _errs1) {
                            if (typeof data0 === 'string') {
                                if (!formats0.test(data0)) {
                                    validate18.errors = [
                                        {
                                            instancePath: instancePath + '/id',
                                            schemaPath: '#/properties/id/format',
                                            keyword: 'format',
                                            params: { format: 'uuid' },
                                            message: 'must match format "' + 'uuid' + '"'
                                        }
                                    ];
                                    return false;
                                }
                            }
                            else {
                                validate18.errors = [
                                    {
                                        instancePath: instancePath + '/id',
                                        schemaPath: '#/properties/id/type',
                                        keyword: 'type',
                                        params: { type: 'string' },
                                        message: 'must be string'
                                    }
                                ];
                                return false;
                            }
                        }
                    }
                    var valid0 = _errs1 === errors;
                }
                else {
                    var valid0 = true;
                }
                if (valid0) {
                    if (data.monthlyCredit !== undefined) {
                        const _errs3 = errors;
                        if (!(typeof data.monthlyCredit == 'number')) {
                            validate18.errors = [
                                {
                                    instancePath: instancePath + '/monthlyCredit',
                                    schemaPath: '#/properties/monthlyCredit/type',
                                    keyword: 'type',
                                    params: { type: 'number' },
                                    message: 'must be number'
                                }
                            ];
                            return false;
                        }
                        var valid0 = _errs3 === errors;
                    }
                    else {
                        var valid0 = true;
                    }
                    if (valid0) {
                        if (data.orgName !== undefined) {
                            let data2 = data.orgName;
                            const _errs5 = errors;
                            if (errors === _errs5) {
                                if (typeof data2 === 'string') {
                                    if (func2(data2) > 100) {
                                        validate18.errors = [
                                            {
                                                instancePath: instancePath + '/orgName',
                                                schemaPath: '#/properties/orgName/maxLength',
                                                keyword: 'maxLength',
                                                params: { limit: 100 },
                                                message: 'must NOT have more than 100 characters'
                                            }
                                        ];
                                        return false;
                                    }
                                    else {
                                        if (func2(data2) < 1) {
                                            validate18.errors = [
                                                {
                                                    instancePath: instancePath + '/orgName',
                                                    schemaPath: '#/properties/orgName/minLength',
                                                    keyword: 'minLength',
                                                    params: { limit: 1 },
                                                    message: 'must NOT have fewer than 1 characters'
                                                }
                                            ];
                                            return false;
                                        }
                                    }
                                }
                                else {
                                    validate18.errors = [
                                        {
                                            instancePath: instancePath + '/orgName',
                                            schemaPath: '#/properties/orgName/type',
                                            keyword: 'type',
                                            params: { type: 'string' },
                                            message: 'must be string'
                                        }
                                    ];
                                    return false;
                                }
                            }
                            var valid0 = _errs5 === errors;
                        }
                        else {
                            var valid0 = true;
                        }
                    }
                }
            }
        }
        else {
            validate18.errors = [
                { instancePath, schemaPath: '#/type', keyword: 'type', params: { type: 'object' }, message: 'must be object' }
            ];
            return false;
        }
    }
    validate18.errors = vErrors;
    return errors === 0;
}
export const orgFeatureFlagSchemaValidation = validate19;
const schema37 = {
    $id: 'urn:wisepipe-domain-authorize:OrgFeatureFlag',
    type: 'object',
    properties: {
        flagName: {
            type: 'string',
            enum: [
                'joinCaseInsensitive',
                'symonSparkPartitionNumber',
                'symonForceDecimal',
                'requireChangeRequest',
                'incentivesRoles',
                'incentivesS3DataProcessing'
            ]
        },
        flagValue: { type: 'string' },
        objectId: { type: 'string' },
        objectType: { type: 'string' }
    },
    required: ['flagName', 'flagValue']
};
function validate19(data, { instancePath = '', parentData, parentDataProperty, rootData = data } = {}) {
    /*# sourceURL="urn:wisepipe-domain-authorize:OrgFeatureFlag" */ let vErrors = null;
    let errors = 0;
    if (errors === 0) {
        if (data && typeof data == 'object' && !Array.isArray(data)) {
            let missing0;
            if ((data.flagName === undefined && (missing0 = 'flagName')) ||
                (data.flagValue === undefined && (missing0 = 'flagValue'))) {
                validate19.errors = [
                    {
                        instancePath,
                        schemaPath: '#/required',
                        keyword: 'required',
                        params: { missingProperty: missing0 },
                        message: "must have required property '" + missing0 + "'"
                    }
                ];
                return false;
            }
            else {
                if (data.flagName !== undefined) {
                    let data0 = data.flagName;
                    const _errs1 = errors;
                    if (typeof data0 !== 'string') {
                        validate19.errors = [
                            {
                                instancePath: instancePath + '/flagName',
                                schemaPath: '#/properties/flagName/type',
                                keyword: 'type',
                                params: { type: 'string' },
                                message: 'must be string'
                            }
                        ];
                        return false;
                    }
                    if (!(data0 === 'joinCaseInsensitive' ||
                        data0 === 'symonSparkPartitionNumber' ||
                        data0 === 'symonForceDecimal' ||
                        data0 === 'requireChangeRequest' ||
                        data0 === 'incentivesRoles' ||
                        data0 === 'incentivesS3DataProcessing')) {
                        validate19.errors = [
                            {
                                instancePath: instancePath + '/flagName',
                                schemaPath: '#/properties/flagName/enum',
                                keyword: 'enum',
                                params: { allowedValues: schema37.properties.flagName.enum },
                                message: 'must be equal to one of the allowed values'
                            }
                        ];
                        return false;
                    }
                    var valid0 = _errs1 === errors;
                }
                else {
                    var valid0 = true;
                }
                if (valid0) {
                    if (data.flagValue !== undefined) {
                        const _errs3 = errors;
                        if (typeof data.flagValue !== 'string') {
                            validate19.errors = [
                                {
                                    instancePath: instancePath + '/flagValue',
                                    schemaPath: '#/properties/flagValue/type',
                                    keyword: 'type',
                                    params: { type: 'string' },
                                    message: 'must be string'
                                }
                            ];
                            return false;
                        }
                        var valid0 = _errs3 === errors;
                    }
                    else {
                        var valid0 = true;
                    }
                    if (valid0) {
                        if (data.objectId !== undefined) {
                            const _errs5 = errors;
                            if (typeof data.objectId !== 'string') {
                                validate19.errors = [
                                    {
                                        instancePath: instancePath + '/objectId',
                                        schemaPath: '#/properties/objectId/type',
                                        keyword: 'type',
                                        params: { type: 'string' },
                                        message: 'must be string'
                                    }
                                ];
                                return false;
                            }
                            var valid0 = _errs5 === errors;
                        }
                        else {
                            var valid0 = true;
                        }
                        if (valid0) {
                            if (data.objectType !== undefined) {
                                const _errs7 = errors;
                                if (typeof data.objectType !== 'string') {
                                    validate19.errors = [
                                        {
                                            instancePath: instancePath + '/objectType',
                                            schemaPath: '#/properties/objectType/type',
                                            keyword: 'type',
                                            params: { type: 'string' },
                                            message: 'must be string'
                                        }
                                    ];
                                    return false;
                                }
                                var valid0 = _errs7 === errors;
                            }
                            else {
                                var valid0 = true;
                            }
                        }
                    }
                }
            }
        }
        else {
            validate19.errors = [
                { instancePath, schemaPath: '#/type', keyword: 'type', params: { type: 'object' }, message: 'must be object' }
            ];
            return false;
        }
    }
    validate19.errors = vErrors;
    return errors === 0;
}
export const orgInfoSchemaValidation = validate20;
const schema38 = {
    $id: 'urn:wisepipe-domain-authorize:OrgInfo',
    type: 'object',
    properties: {
        id: { type: 'string', format: 'uuid' },
        name: { type: 'string', minLength: 1, maxLength: 100 },
        orgPlan: { type: 'string', enum: ['Social', 'Enterprise', 'Integration', 'Temp', 'Starter', 'Professional'] },
        initialCredit: { type: 'number', minimum: 0 },
        seats: { type: 'number', minimum: 0 },
        createdAt: { type: 'string', format: 'date-time' },
        supportedLoginTypes: { type: 'array', items: { type: 'string' } },
        featureFlags: { type: 'array', items: { $ref: 'urn:wisepipe-domain-authorize:OrgFeatureFlag' } },
        salesforceAcctId: { type: 'string' },
        orgType: { type: 'string', enum: ['DEV', 'QA', 'PROD'] },
        orgTimezone: { type: 'string', minLength: 1 }
    },
    required: ['id', 'name', 'orgPlan', 'initialCredit', 'seats']
};
function validate20(data, { instancePath = '', parentData, parentDataProperty, rootData = data } = {}) {
    /*# sourceURL="urn:wisepipe-domain-authorize:OrgInfo" */ let vErrors = null;
    let errors = 0;
    if (errors === 0) {
        if (data && typeof data == 'object' && !Array.isArray(data)) {
            let missing0;
            if ((data.id === undefined && (missing0 = 'id')) ||
                (data.name === undefined && (missing0 = 'name')) ||
                (data.orgPlan === undefined && (missing0 = 'orgPlan')) ||
                (data.initialCredit === undefined && (missing0 = 'initialCredit')) ||
                (data.seats === undefined && (missing0 = 'seats'))) {
                validate20.errors = [
                    {
                        instancePath,
                        schemaPath: '#/required',
                        keyword: 'required',
                        params: { missingProperty: missing0 },
                        message: "must have required property '" + missing0 + "'"
                    }
                ];
                return false;
            }
            else {
                if (data.id !== undefined) {
                    let data0 = data.id;
                    const _errs1 = errors;
                    if (errors === _errs1) {
                        if (errors === _errs1) {
                            if (typeof data0 === 'string') {
                                if (!formats0.test(data0)) {
                                    validate20.errors = [
                                        {
                                            instancePath: instancePath + '/id',
                                            schemaPath: '#/properties/id/format',
                                            keyword: 'format',
                                            params: { format: 'uuid' },
                                            message: 'must match format "' + 'uuid' + '"'
                                        }
                                    ];
                                    return false;
                                }
                            }
                            else {
                                validate20.errors = [
                                    {
                                        instancePath: instancePath + '/id',
                                        schemaPath: '#/properties/id/type',
                                        keyword: 'type',
                                        params: { type: 'string' },
                                        message: 'must be string'
                                    }
                                ];
                                return false;
                            }
                        }
                    }
                    var valid0 = _errs1 === errors;
                }
                else {
                    var valid0 = true;
                }
                if (valid0) {
                    if (data.name !== undefined) {
                        let data1 = data.name;
                        const _errs3 = errors;
                        if (errors === _errs3) {
                            if (typeof data1 === 'string') {
                                if (func2(data1) > 100) {
                                    validate20.errors = [
                                        {
                                            instancePath: instancePath + '/name',
                                            schemaPath: '#/properties/name/maxLength',
                                            keyword: 'maxLength',
                                            params: { limit: 100 },
                                            message: 'must NOT have more than 100 characters'
                                        }
                                    ];
                                    return false;
                                }
                                else {
                                    if (func2(data1) < 1) {
                                        validate20.errors = [
                                            {
                                                instancePath: instancePath + '/name',
                                                schemaPath: '#/properties/name/minLength',
                                                keyword: 'minLength',
                                                params: { limit: 1 },
                                                message: 'must NOT have fewer than 1 characters'
                                            }
                                        ];
                                        return false;
                                    }
                                }
                            }
                            else {
                                validate20.errors = [
                                    {
                                        instancePath: instancePath + '/name',
                                        schemaPath: '#/properties/name/type',
                                        keyword: 'type',
                                        params: { type: 'string' },
                                        message: 'must be string'
                                    }
                                ];
                                return false;
                            }
                        }
                        var valid0 = _errs3 === errors;
                    }
                    else {
                        var valid0 = true;
                    }
                    if (valid0) {
                        if (data.orgPlan !== undefined) {
                            let data2 = data.orgPlan;
                            const _errs5 = errors;
                            if (typeof data2 !== 'string') {
                                validate20.errors = [
                                    {
                                        instancePath: instancePath + '/orgPlan',
                                        schemaPath: '#/properties/orgPlan/type',
                                        keyword: 'type',
                                        params: { type: 'string' },
                                        message: 'must be string'
                                    }
                                ];
                                return false;
                            }
                            if (!(data2 === 'Social' ||
                                data2 === 'Enterprise' ||
                                data2 === 'Integration' ||
                                data2 === 'Temp' ||
                                data2 === 'Starter' ||
                                data2 === 'Professional')) {
                                validate20.errors = [
                                    {
                                        instancePath: instancePath + '/orgPlan',
                                        schemaPath: '#/properties/orgPlan/enum',
                                        keyword: 'enum',
                                        params: { allowedValues: schema38.properties.orgPlan.enum },
                                        message: 'must be equal to one of the allowed values'
                                    }
                                ];
                                return false;
                            }
                            var valid0 = _errs5 === errors;
                        }
                        else {
                            var valid0 = true;
                        }
                        if (valid0) {
                            if (data.initialCredit !== undefined) {
                                let data3 = data.initialCredit;
                                const _errs7 = errors;
                                if (errors === _errs7) {
                                    if (typeof data3 == 'number') {
                                        if (data3 < 0 || isNaN(data3)) {
                                            validate20.errors = [
                                                {
                                                    instancePath: instancePath + '/initialCredit',
                                                    schemaPath: '#/properties/initialCredit/minimum',
                                                    keyword: 'minimum',
                                                    params: { comparison: '>=', limit: 0 },
                                                    message: 'must be >= 0'
                                                }
                                            ];
                                            return false;
                                        }
                                    }
                                    else {
                                        validate20.errors = [
                                            {
                                                instancePath: instancePath + '/initialCredit',
                                                schemaPath: '#/properties/initialCredit/type',
                                                keyword: 'type',
                                                params: { type: 'number' },
                                                message: 'must be number'
                                            }
                                        ];
                                        return false;
                                    }
                                }
                                var valid0 = _errs7 === errors;
                            }
                            else {
                                var valid0 = true;
                            }
                            if (valid0) {
                                if (data.seats !== undefined) {
                                    let data4 = data.seats;
                                    const _errs9 = errors;
                                    if (errors === _errs9) {
                                        if (typeof data4 == 'number') {
                                            if (data4 < 0 || isNaN(data4)) {
                                                validate20.errors = [
                                                    {
                                                        instancePath: instancePath + '/seats',
                                                        schemaPath: '#/properties/seats/minimum',
                                                        keyword: 'minimum',
                                                        params: { comparison: '>=', limit: 0 },
                                                        message: 'must be >= 0'
                                                    }
                                                ];
                                                return false;
                                            }
                                        }
                                        else {
                                            validate20.errors = [
                                                {
                                                    instancePath: instancePath + '/seats',
                                                    schemaPath: '#/properties/seats/type',
                                                    keyword: 'type',
                                                    params: { type: 'number' },
                                                    message: 'must be number'
                                                }
                                            ];
                                            return false;
                                        }
                                    }
                                    var valid0 = _errs9 === errors;
                                }
                                else {
                                    var valid0 = true;
                                }
                                if (valid0) {
                                    if (data.createdAt !== undefined) {
                                        let data5 = data.createdAt;
                                        const _errs11 = errors;
                                        if (errors === _errs11) {
                                            if (errors === _errs11) {
                                                if (typeof data5 === 'string') {
                                                    if (!formats8.validate(data5)) {
                                                        validate20.errors = [
                                                            {
                                                                instancePath: instancePath + '/createdAt',
                                                                schemaPath: '#/properties/createdAt/format',
                                                                keyword: 'format',
                                                                params: { format: 'date-time' },
                                                                message: 'must match format "' + 'date-time' + '"'
                                                            }
                                                        ];
                                                        return false;
                                                    }
                                                }
                                                else {
                                                    validate20.errors = [
                                                        {
                                                            instancePath: instancePath + '/createdAt',
                                                            schemaPath: '#/properties/createdAt/type',
                                                            keyword: 'type',
                                                            params: { type: 'string' },
                                                            message: 'must be string'
                                                        }
                                                    ];
                                                    return false;
                                                }
                                            }
                                        }
                                        var valid0 = _errs11 === errors;
                                    }
                                    else {
                                        var valid0 = true;
                                    }
                                    if (valid0) {
                                        if (data.supportedLoginTypes !== undefined) {
                                            let data6 = data.supportedLoginTypes;
                                            const _errs13 = errors;
                                            if (errors === _errs13) {
                                                if (Array.isArray(data6)) {
                                                    var valid1 = true;
                                                    const len0 = data6.length;
                                                    for (let i0 = 0; i0 < len0; i0++) {
                                                        const _errs15 = errors;
                                                        if (typeof data6[i0] !== 'string') {
                                                            validate20.errors = [
                                                                {
                                                                    instancePath: instancePath + '/supportedLoginTypes/' + i0,
                                                                    schemaPath: '#/properties/supportedLoginTypes/items/type',
                                                                    keyword: 'type',
                                                                    params: { type: 'string' },
                                                                    message: 'must be string'
                                                                }
                                                            ];
                                                            return false;
                                                        }
                                                        var valid1 = _errs15 === errors;
                                                        if (!valid1) {
                                                            break;
                                                        }
                                                    }
                                                }
                                                else {
                                                    validate20.errors = [
                                                        {
                                                            instancePath: instancePath + '/supportedLoginTypes',
                                                            schemaPath: '#/properties/supportedLoginTypes/type',
                                                            keyword: 'type',
                                                            params: { type: 'array' },
                                                            message: 'must be array'
                                                        }
                                                    ];
                                                    return false;
                                                }
                                            }
                                            var valid0 = _errs13 === errors;
                                        }
                                        else {
                                            var valid0 = true;
                                        }
                                        if (valid0) {
                                            if (data.featureFlags !== undefined) {
                                                let data8 = data.featureFlags;
                                                const _errs17 = errors;
                                                if (errors === _errs17) {
                                                    if (Array.isArray(data8)) {
                                                        var valid2 = true;
                                                        const len1 = data8.length;
                                                        for (let i1 = 0; i1 < len1; i1++) {
                                                            let data9 = data8[i1];
                                                            const _errs19 = errors;
                                                            const _errs20 = errors;
                                                            if (errors === _errs20) {
                                                                if (data9 && typeof data9 == 'object' && !Array.isArray(data9)) {
                                                                    let missing1;
                                                                    if ((data9.flagName === undefined && (missing1 = 'flagName')) ||
                                                                        (data9.flagValue === undefined && (missing1 = 'flagValue'))) {
                                                                        validate20.errors = [
                                                                            {
                                                                                instancePath: instancePath + '/featureFlags/' + i1,
                                                                                schemaPath: 'urn:wisepipe-domain-authorize:OrgFeatureFlag/required',
                                                                                keyword: 'required',
                                                                                params: { missingProperty: missing1 },
                                                                                message: "must have required property '" + missing1 + "'"
                                                                            }
                                                                        ];
                                                                        return false;
                                                                    }
                                                                    else {
                                                                        if (data9.flagName !== undefined) {
                                                                            let data10 = data9.flagName;
                                                                            const _errs22 = errors;
                                                                            if (typeof data10 !== 'string') {
                                                                                validate20.errors = [
                                                                                    {
                                                                                        instancePath: instancePath + '/featureFlags/' + i1 + '/flagName',
                                                                                        schemaPath: 'urn:wisepipe-domain-authorize:OrgFeatureFlag/properties/flagName/type',
                                                                                        keyword: 'type',
                                                                                        params: { type: 'string' },
                                                                                        message: 'must be string'
                                                                                    }
                                                                                ];
                                                                                return false;
                                                                            }
                                                                            if (!(data10 === 'joinCaseInsensitive' ||
                                                                                data10 === 'symonSparkPartitionNumber' ||
                                                                                data10 === 'symonForceDecimal' ||
                                                                                data10 === 'requireChangeRequest' ||
                                                                                data10 === 'incentivesRoles' ||
                                                                                data10 === 'incentivesS3DataProcessing')) {
                                                                                validate20.errors = [
                                                                                    {
                                                                                        instancePath: instancePath + '/featureFlags/' + i1 + '/flagName',
                                                                                        schemaPath: 'urn:wisepipe-domain-authorize:OrgFeatureFlag/properties/flagName/enum',
                                                                                        keyword: 'enum',
                                                                                        params: { allowedValues: schema37.properties.flagName.enum },
                                                                                        message: 'must be equal to one of the allowed values'
                                                                                    }
                                                                                ];
                                                                                return false;
                                                                            }
                                                                            var valid4 = _errs22 === errors;
                                                                        }
                                                                        else {
                                                                            var valid4 = true;
                                                                        }
                                                                        if (valid4) {
                                                                            if (data9.flagValue !== undefined) {
                                                                                const _errs24 = errors;
                                                                                if (typeof data9.flagValue !== 'string') {
                                                                                    validate20.errors = [
                                                                                        {
                                                                                            instancePath: instancePath + '/featureFlags/' + i1 + '/flagValue',
                                                                                            schemaPath: 'urn:wisepipe-domain-authorize:OrgFeatureFlag/properties/flagValue/type',
                                                                                            keyword: 'type',
                                                                                            params: { type: 'string' },
                                                                                            message: 'must be string'
                                                                                        }
                                                                                    ];
                                                                                    return false;
                                                                                }
                                                                                var valid4 = _errs24 === errors;
                                                                            }
                                                                            else {
                                                                                var valid4 = true;
                                                                            }
                                                                            if (valid4) {
                                                                                if (data9.objectId !== undefined) {
                                                                                    const _errs26 = errors;
                                                                                    if (typeof data9.objectId !== 'string') {
                                                                                        validate20.errors = [
                                                                                            {
                                                                                                instancePath: instancePath + '/featureFlags/' + i1 + '/objectId',
                                                                                                schemaPath: 'urn:wisepipe-domain-authorize:OrgFeatureFlag/properties/objectId/type',
                                                                                                keyword: 'type',
                                                                                                params: { type: 'string' },
                                                                                                message: 'must be string'
                                                                                            }
                                                                                        ];
                                                                                        return false;
                                                                                    }
                                                                                    var valid4 = _errs26 === errors;
                                                                                }
                                                                                else {
                                                                                    var valid4 = true;
                                                                                }
                                                                                if (valid4) {
                                                                                    if (data9.objectType !== undefined) {
                                                                                        const _errs28 = errors;
                                                                                        if (typeof data9.objectType !== 'string') {
                                                                                            validate20.errors = [
                                                                                                {
                                                                                                    instancePath: instancePath + '/featureFlags/' + i1 + '/objectType',
                                                                                                    schemaPath: 'urn:wisepipe-domain-authorize:OrgFeatureFlag/properties/objectType/type',
                                                                                                    keyword: 'type',
                                                                                                    params: { type: 'string' },
                                                                                                    message: 'must be string'
                                                                                                }
                                                                                            ];
                                                                                            return false;
                                                                                        }
                                                                                        var valid4 = _errs28 === errors;
                                                                                    }
                                                                                    else {
                                                                                        var valid4 = true;
                                                                                    }
                                                                                }
                                                                            }
                                                                        }
                                                                    }
                                                                }
                                                                else {
                                                                    validate20.errors = [
                                                                        {
                                                                            instancePath: instancePath + '/featureFlags/' + i1,
                                                                            schemaPath: 'urn:wisepipe-domain-authorize:OrgFeatureFlag/type',
                                                                            keyword: 'type',
                                                                            params: { type: 'object' },
                                                                            message: 'must be object'
                                                                        }
                                                                    ];
                                                                    return false;
                                                                }
                                                            }
                                                            var valid2 = _errs19 === errors;
                                                            if (!valid2) {
                                                                break;
                                                            }
                                                        }
                                                    }
                                                    else {
                                                        validate20.errors = [
                                                            {
                                                                instancePath: instancePath + '/featureFlags',
                                                                schemaPath: '#/properties/featureFlags/type',
                                                                keyword: 'type',
                                                                params: { type: 'array' },
                                                                message: 'must be array'
                                                            }
                                                        ];
                                                        return false;
                                                    }
                                                }
                                                var valid0 = _errs17 === errors;
                                            }
                                            else {
                                                var valid0 = true;
                                            }
                                            if (valid0) {
                                                if (data.salesforceAcctId !== undefined) {
                                                    const _errs30 = errors;
                                                    if (typeof data.salesforceAcctId !== 'string') {
                                                        validate20.errors = [
                                                            {
                                                                instancePath: instancePath + '/salesforceAcctId',
                                                                schemaPath: '#/properties/salesforceAcctId/type',
                                                                keyword: 'type',
                                                                params: { type: 'string' },
                                                                message: 'must be string'
                                                            }
                                                        ];
                                                        return false;
                                                    }
                                                    var valid0 = _errs30 === errors;
                                                }
                                                else {
                                                    var valid0 = true;
                                                }
                                                if (valid0) {
                                                    if (data.orgType !== undefined) {
                                                        let data15 = data.orgType;
                                                        const _errs32 = errors;
                                                        if (typeof data15 !== 'string') {
                                                            validate20.errors = [
                                                                {
                                                                    instancePath: instancePath + '/orgType',
                                                                    schemaPath: '#/properties/orgType/type',
                                                                    keyword: 'type',
                                                                    params: { type: 'string' },
                                                                    message: 'must be string'
                                                                }
                                                            ];
                                                            return false;
                                                        }
                                                        if (!(data15 === 'DEV' || data15 === 'QA' || data15 === 'PROD')) {
                                                            validate20.errors = [
                                                                {
                                                                    instancePath: instancePath + '/orgType',
                                                                    schemaPath: '#/properties/orgType/enum',
                                                                    keyword: 'enum',
                                                                    params: { allowedValues: schema38.properties.orgType.enum },
                                                                    message: 'must be equal to one of the allowed values'
                                                                }
                                                            ];
                                                            return false;
                                                        }
                                                        var valid0 = _errs32 === errors;
                                                    }
                                                    else {
                                                        var valid0 = true;
                                                    }
                                                    if (valid0) {
                                                        if (data.orgTimezone !== undefined) {
                                                            let data16 = data.orgTimezone;
                                                            const _errs34 = errors;
                                                            if (errors === _errs34) {
                                                                if (typeof data16 === 'string') {
                                                                    if (func2(data16) < 1) {
                                                                        validate20.errors = [
                                                                            {
                                                                                instancePath: instancePath + '/orgTimezone',
                                                                                schemaPath: '#/properties/orgTimezone/minLength',
                                                                                keyword: 'minLength',
                                                                                params: { limit: 1 },
                                                                                message: 'must NOT have fewer than 1 characters'
                                                                            }
                                                                        ];
                                                                        return false;
                                                                    }
                                                                }
                                                                else {
                                                                    validate20.errors = [
                                                                        {
                                                                            instancePath: instancePath + '/orgTimezone',
                                                                            schemaPath: '#/properties/orgTimezone/type',
                                                                            keyword: 'type',
                                                                            params: { type: 'string' },
                                                                            message: 'must be string'
                                                                        }
                                                                    ];
                                                                    return false;
                                                                }
                                                            }
                                                            var valid0 = _errs34 === errors;
                                                        }
                                                        else {
                                                            var valid0 = true;
                                                        }
                                                    }
                                                }
                                            }
                                        }
                                    }
                                }
                            }
                        }
                    }
                }
            }
        }
        else {
            validate20.errors = [
                { instancePath, schemaPath: '#/type', keyword: 'type', params: { type: 'object' }, message: 'must be object' }
            ];
            return false;
        }
    }
    validate20.errors = vErrors;
    return errors === 0;
}
export const orgUserInfoForExportSchemaValidation = validate21;
const schema40 = {
    $id: 'urn:wisepipe-domain-authorize:OrgUserInfoForExport',
    type: 'object',
    properties: {
        email: { type: 'string', minLength: 1 },
        name: { type: ['string', 'null'] },
        userID: { type: 'string', format: 'uuid' },
        role: { type: 'string', minLength: 1 },
        supportUser: { type: 'boolean' },
        createdAt: { type: 'string', format: 'date-time' },
        acceptedAt: { type: 'string', format: 'date-time' },
        lastLoginAt: { type: 'string', format: 'date-time' }
    },
    required: ['email', 'userID', 'createdAt']
};
function validate21(data, { instancePath = '', parentData, parentDataProperty, rootData = data } = {}) {
    /*# sourceURL="urn:wisepipe-domain-authorize:OrgUserInfoForExport" */ let vErrors = null;
    let errors = 0;
    if (errors === 0) {
        if (data && typeof data == 'object' && !Array.isArray(data)) {
            let missing0;
            if ((data.email === undefined && (missing0 = 'email')) ||
                (data.userID === undefined && (missing0 = 'userID')) ||
                (data.createdAt === undefined && (missing0 = 'createdAt'))) {
                validate21.errors = [
                    {
                        instancePath,
                        schemaPath: '#/required',
                        keyword: 'required',
                        params: { missingProperty: missing0 },
                        message: "must have required property '" + missing0 + "'"
                    }
                ];
                return false;
            }
            else {
                if (data.email !== undefined) {
                    let data0 = data.email;
                    const _errs1 = errors;
                    if (errors === _errs1) {
                        if (typeof data0 === 'string') {
                            if (func2(data0) < 1) {
                                validate21.errors = [
                                    {
                                        instancePath: instancePath + '/email',
                                        schemaPath: '#/properties/email/minLength',
                                        keyword: 'minLength',
                                        params: { limit: 1 },
                                        message: 'must NOT have fewer than 1 characters'
                                    }
                                ];
                                return false;
                            }
                        }
                        else {
                            validate21.errors = [
                                {
                                    instancePath: instancePath + '/email',
                                    schemaPath: '#/properties/email/type',
                                    keyword: 'type',
                                    params: { type: 'string' },
                                    message: 'must be string'
                                }
                            ];
                            return false;
                        }
                    }
                    var valid0 = _errs1 === errors;
                }
                else {
                    var valid0 = true;
                }
                if (valid0) {
                    if (data.name !== undefined) {
                        let data1 = data.name;
                        const _errs3 = errors;
                        if (typeof data1 !== 'string' && data1 !== null) {
                            validate21.errors = [
                                {
                                    instancePath: instancePath + '/name',
                                    schemaPath: '#/properties/name/type',
                                    keyword: 'type',
                                    params: { type: schema40.properties.name.type },
                                    message: 'must be string,null'
                                }
                            ];
                            return false;
                        }
                        var valid0 = _errs3 === errors;
                    }
                    else {
                        var valid0 = true;
                    }
                    if (valid0) {
                        if (data.userID !== undefined) {
                            let data2 = data.userID;
                            const _errs5 = errors;
                            if (errors === _errs5) {
                                if (errors === _errs5) {
                                    if (typeof data2 === 'string') {
                                        if (!formats0.test(data2)) {
                                            validate21.errors = [
                                                {
                                                    instancePath: instancePath + '/userID',
                                                    schemaPath: '#/properties/userID/format',
                                                    keyword: 'format',
                                                    params: { format: 'uuid' },
                                                    message: 'must match format "' + 'uuid' + '"'
                                                }
                                            ];
                                            return false;
                                        }
                                    }
                                    else {
                                        validate21.errors = [
                                            {
                                                instancePath: instancePath + '/userID',
                                                schemaPath: '#/properties/userID/type',
                                                keyword: 'type',
                                                params: { type: 'string' },
                                                message: 'must be string'
                                            }
                                        ];
                                        return false;
                                    }
                                }
                            }
                            var valid0 = _errs5 === errors;
                        }
                        else {
                            var valid0 = true;
                        }
                        if (valid0) {
                            if (data.role !== undefined) {
                                let data3 = data.role;
                                const _errs7 = errors;
                                if (errors === _errs7) {
                                    if (typeof data3 === 'string') {
                                        if (func2(data3) < 1) {
                                            validate21.errors = [
                                                {
                                                    instancePath: instancePath + '/role',
                                                    schemaPath: '#/properties/role/minLength',
                                                    keyword: 'minLength',
                                                    params: { limit: 1 },
                                                    message: 'must NOT have fewer than 1 characters'
                                                }
                                            ];
                                            return false;
                                        }
                                    }
                                    else {
                                        validate21.errors = [
                                            {
                                                instancePath: instancePath + '/role',
                                                schemaPath: '#/properties/role/type',
                                                keyword: 'type',
                                                params: { type: 'string' },
                                                message: 'must be string'
                                            }
                                        ];
                                        return false;
                                    }
                                }
                                var valid0 = _errs7 === errors;
                            }
                            else {
                                var valid0 = true;
                            }
                            if (valid0) {
                                if (data.supportUser !== undefined) {
                                    const _errs9 = errors;
                                    if (typeof data.supportUser !== 'boolean') {
                                        validate21.errors = [
                                            {
                                                instancePath: instancePath + '/supportUser',
                                                schemaPath: '#/properties/supportUser/type',
                                                keyword: 'type',
                                                params: { type: 'boolean' },
                                                message: 'must be boolean'
                                            }
                                        ];
                                        return false;
                                    }
                                    var valid0 = _errs9 === errors;
                                }
                                else {
                                    var valid0 = true;
                                }
                                if (valid0) {
                                    if (data.createdAt !== undefined) {
                                        let data5 = data.createdAt;
                                        const _errs11 = errors;
                                        if (errors === _errs11) {
                                            if (errors === _errs11) {
                                                if (typeof data5 === 'string') {
                                                    if (!formats8.validate(data5)) {
                                                        validate21.errors = [
                                                            {
                                                                instancePath: instancePath + '/createdAt',
                                                                schemaPath: '#/properties/createdAt/format',
                                                                keyword: 'format',
                                                                params: { format: 'date-time' },
                                                                message: 'must match format "' + 'date-time' + '"'
                                                            }
                                                        ];
                                                        return false;
                                                    }
                                                }
                                                else {
                                                    validate21.errors = [
                                                        {
                                                            instancePath: instancePath + '/createdAt',
                                                            schemaPath: '#/properties/createdAt/type',
                                                            keyword: 'type',
                                                            params: { type: 'string' },
                                                            message: 'must be string'
                                                        }
                                                    ];
                                                    return false;
                                                }
                                            }
                                        }
                                        var valid0 = _errs11 === errors;
                                    }
                                    else {
                                        var valid0 = true;
                                    }
                                    if (valid0) {
                                        if (data.acceptedAt !== undefined) {
                                            let data6 = data.acceptedAt;
                                            const _errs13 = errors;
                                            if (errors === _errs13) {
                                                if (errors === _errs13) {
                                                    if (typeof data6 === 'string') {
                                                        if (!formats8.validate(data6)) {
                                                            validate21.errors = [
                                                                {
                                                                    instancePath: instancePath + '/acceptedAt',
                                                                    schemaPath: '#/properties/acceptedAt/format',
                                                                    keyword: 'format',
                                                                    params: { format: 'date-time' },
                                                                    message: 'must match format "' + 'date-time' + '"'
                                                                }
                                                            ];
                                                            return false;
                                                        }
                                                    }
                                                    else {
                                                        validate21.errors = [
                                                            {
                                                                instancePath: instancePath + '/acceptedAt',
                                                                schemaPath: '#/properties/acceptedAt/type',
                                                                keyword: 'type',
                                                                params: { type: 'string' },
                                                                message: 'must be string'
                                                            }
                                                        ];
                                                        return false;
                                                    }
                                                }
                                            }
                                            var valid0 = _errs13 === errors;
                                        }
                                        else {
                                            var valid0 = true;
                                        }
                                        if (valid0) {
                                            if (data.lastLoginAt !== undefined) {
                                                let data7 = data.lastLoginAt;
                                                const _errs15 = errors;
                                                if (errors === _errs15) {
                                                    if (errors === _errs15) {
                                                        if (typeof data7 === 'string') {
                                                            if (!formats8.validate(data7)) {
                                                                validate21.errors = [
                                                                    {
                                                                        instancePath: instancePath + '/lastLoginAt',
                                                                        schemaPath: '#/properties/lastLoginAt/format',
                                                                        keyword: 'format',
                                                                        params: { format: 'date-time' },
                                                                        message: 'must match format "' + 'date-time' + '"'
                                                                    }
                                                                ];
                                                                return false;
                                                            }
                                                        }
                                                        else {
                                                            validate21.errors = [
                                                                {
                                                                    instancePath: instancePath + '/lastLoginAt',
                                                                    schemaPath: '#/properties/lastLoginAt/type',
                                                                    keyword: 'type',
                                                                    params: { type: 'string' },
                                                                    message: 'must be string'
                                                                }
                                                            ];
                                                            return false;
                                                        }
                                                    }
                                                }
                                                var valid0 = _errs15 === errors;
                                            }
                                            else {
                                                var valid0 = true;
                                            }
                                        }
                                    }
                                }
                            }
                        }
                    }
                }
            }
        }
        else {
            validate21.errors = [
                { instancePath, schemaPath: '#/type', keyword: 'type', params: { type: 'object' }, message: 'must be object' }
            ];
            return false;
        }
    }
    validate21.errors = vErrors;
    return errors === 0;
}
export const orgUserInfoSchemaValidation = validate22;
const schema41 = {
    $id: 'urn:wisepipe-domain-authorize:OrgUserInfo',
    type: 'object',
    properties: { name: { type: ['string', 'null'] }, email: { type: ['string', 'null'] } }
};
function validate22(data, { instancePath = '', parentData, parentDataProperty, rootData = data } = {}) {
    /*# sourceURL="urn:wisepipe-domain-authorize:OrgUserInfo" */ let vErrors = null;
    let errors = 0;
    if (errors === 0) {
        if (data && typeof data == 'object' && !Array.isArray(data)) {
            if (data.name !== undefined) {
                let data0 = data.name;
                const _errs1 = errors;
                if (typeof data0 !== 'string' && data0 !== null) {
                    validate22.errors = [
                        {
                            instancePath: instancePath + '/name',
                            schemaPath: '#/properties/name/type',
                            keyword: 'type',
                            params: { type: schema41.properties.name.type },
                            message: 'must be string,null'
                        }
                    ];
                    return false;
                }
                var valid0 = _errs1 === errors;
            }
            else {
                var valid0 = true;
            }
            if (valid0) {
                if (data.email !== undefined) {
                    let data1 = data.email;
                    const _errs3 = errors;
                    if (typeof data1 !== 'string' && data1 !== null) {
                        validate22.errors = [
                            {
                                instancePath: instancePath + '/email',
                                schemaPath: '#/properties/email/type',
                                keyword: 'type',
                                params: { type: schema41.properties.email.type },
                                message: 'must be string,null'
                            }
                        ];
                        return false;
                    }
                    var valid0 = _errs3 === errors;
                }
                else {
                    var valid0 = true;
                }
            }
        }
        else {
            validate22.errors = [
                { instancePath, schemaPath: '#/type', keyword: 'type', params: { type: 'object' }, message: 'must be object' }
            ];
            return false;
        }
    }
    validate22.errors = vErrors;
    return errors === 0;
}
export const orgUserInviteInfoSchemaValidation = validate23;
const schema42 = {
    $id: 'urn:wisepipe-domain-authorize:OrgUserInviteInfo',
    type: 'object',
    properties: {
        isTemp: { type: 'boolean' },
        orgUserInvites: { type: 'array', items: { $ref: 'urn:wisepipe-domain-authorize:OrgUserInvite' } }
    },
    required: ['isTemp', 'orgUserInvites']
};
const schema43 = {
    $id: 'urn:wisepipe-domain-authorize:OrgUserInvite',
    type: 'object',
    properties: {
        orgInfo: { $ref: 'urn:wisepipe-domain-authorize:OrgInfo' },
        userEmail: { type: 'string', minLength: 1 },
        inviterUserID: { type: 'string', format: 'uuid' },
        userID: { type: 'string', format: 'uuid' },
        cognitoUserID: { type: 'string' },
        roleID: { type: 'string', format: 'uuid' },
        supportUser: { type: 'boolean' },
        currentRoleID: { type: 'string', format: 'uuid' },
        createdAt: { type: 'string', format: 'date-time' },
        acceptedAt: { type: 'string', format: 'date-time' },
        rejectedAt: { type: 'string', format: 'date-time' }
    },
    required: ['orgInfo', 'userEmail', 'createdAt'],
    not: { required: ['acceptedAt', 'rejectedAt'] }
};
function validate24(data, { instancePath = '', parentData, parentDataProperty, rootData = data } = {}) {
    /*# sourceURL="urn:wisepipe-domain-authorize:OrgUserInvite" */ let vErrors = null;
    let errors = 0;
    const _errs1 = errors;
    const _errs2 = errors;
    if (data && typeof data == 'object' && !Array.isArray(data)) {
        let missing0;
        if ((data.acceptedAt === undefined && (missing0 = 'acceptedAt')) ||
            (data.rejectedAt === undefined && (missing0 = 'rejectedAt'))) {
            const err0 = {};
            if (vErrors === null) {
                vErrors = [err0];
            }
            else {
                vErrors.push(err0);
            }
            errors++;
        }
    }
    var valid0 = _errs2 === errors;
    if (valid0) {
        validate24.errors = [
            { instancePath, schemaPath: '#/not', keyword: 'not', params: {}, message: 'must NOT be valid' }
        ];
        return false;
    }
    else {
        errors = _errs1;
        if (vErrors !== null) {
            if (_errs1) {
                vErrors.length = _errs1;
            }
            else {
                vErrors = null;
            }
        }
    }
    if (errors === 0) {
        if (data && typeof data == 'object' && !Array.isArray(data)) {
            let missing1;
            if ((data.orgInfo === undefined && (missing1 = 'orgInfo')) ||
                (data.userEmail === undefined && (missing1 = 'userEmail')) ||
                (data.createdAt === undefined && (missing1 = 'createdAt'))) {
                validate24.errors = [
                    {
                        instancePath,
                        schemaPath: '#/required',
                        keyword: 'required',
                        params: { missingProperty: missing1 },
                        message: "must have required property '" + missing1 + "'"
                    }
                ];
                return false;
            }
            else {
                if (data.orgInfo !== undefined) {
                    const _errs3 = errors;
                    if (!validate20(data.orgInfo, {
                        instancePath: instancePath + '/orgInfo',
                        parentData: data,
                        parentDataProperty: 'orgInfo',
                        rootData
                    })) {
                        vErrors = vErrors === null ? validate20.errors : vErrors.concat(validate20.errors);
                        errors = vErrors.length;
                    }
                    var valid1 = _errs3 === errors;
                }
                else {
                    var valid1 = true;
                }
                if (valid1) {
                    if (data.userEmail !== undefined) {
                        let data1 = data.userEmail;
                        const _errs4 = errors;
                        if (errors === _errs4) {
                            if (typeof data1 === 'string') {
                                if (func2(data1) < 1) {
                                    validate24.errors = [
                                        {
                                            instancePath: instancePath + '/userEmail',
                                            schemaPath: '#/properties/userEmail/minLength',
                                            keyword: 'minLength',
                                            params: { limit: 1 },
                                            message: 'must NOT have fewer than 1 characters'
                                        }
                                    ];
                                    return false;
                                }
                            }
                            else {
                                validate24.errors = [
                                    {
                                        instancePath: instancePath + '/userEmail',
                                        schemaPath: '#/properties/userEmail/type',
                                        keyword: 'type',
                                        params: { type: 'string' },
                                        message: 'must be string'
                                    }
                                ];
                                return false;
                            }
                        }
                        var valid1 = _errs4 === errors;
                    }
                    else {
                        var valid1 = true;
                    }
                    if (valid1) {
                        if (data.inviterUserID !== undefined) {
                            let data2 = data.inviterUserID;
                            const _errs6 = errors;
                            if (errors === _errs6) {
                                if (errors === _errs6) {
                                    if (typeof data2 === 'string') {
                                        if (!formats0.test(data2)) {
                                            validate24.errors = [
                                                {
                                                    instancePath: instancePath + '/inviterUserID',
                                                    schemaPath: '#/properties/inviterUserID/format',
                                                    keyword: 'format',
                                                    params: { format: 'uuid' },
                                                    message: 'must match format "' + 'uuid' + '"'
                                                }
                                            ];
                                            return false;
                                        }
                                    }
                                    else {
                                        validate24.errors = [
                                            {
                                                instancePath: instancePath + '/inviterUserID',
                                                schemaPath: '#/properties/inviterUserID/type',
                                                keyword: 'type',
                                                params: { type: 'string' },
                                                message: 'must be string'
                                            }
                                        ];
                                        return false;
                                    }
                                }
                            }
                            var valid1 = _errs6 === errors;
                        }
                        else {
                            var valid1 = true;
                        }
                        if (valid1) {
                            if (data.userID !== undefined) {
                                let data3 = data.userID;
                                const _errs8 = errors;
                                if (errors === _errs8) {
                                    if (errors === _errs8) {
                                        if (typeof data3 === 'string') {
                                            if (!formats0.test(data3)) {
                                                validate24.errors = [
                                                    {
                                                        instancePath: instancePath + '/userID',
                                                        schemaPath: '#/properties/userID/format',
                                                        keyword: 'format',
                                                        params: { format: 'uuid' },
                                                        message: 'must match format "' + 'uuid' + '"'
                                                    }
                                                ];
                                                return false;
                                            }
                                        }
                                        else {
                                            validate24.errors = [
                                                {
                                                    instancePath: instancePath + '/userID',
                                                    schemaPath: '#/properties/userID/type',
                                                    keyword: 'type',
                                                    params: { type: 'string' },
                                                    message: 'must be string'
                                                }
                                            ];
                                            return false;
                                        }
                                    }
                                }
                                var valid1 = _errs8 === errors;
                            }
                            else {
                                var valid1 = true;
                            }
                            if (valid1) {
                                if (data.cognitoUserID !== undefined) {
                                    const _errs10 = errors;
                                    if (typeof data.cognitoUserID !== 'string') {
                                        validate24.errors = [
                                            {
                                                instancePath: instancePath + '/cognitoUserID',
                                                schemaPath: '#/properties/cognitoUserID/type',
                                                keyword: 'type',
                                                params: { type: 'string' },
                                                message: 'must be string'
                                            }
                                        ];
                                        return false;
                                    }
                                    var valid1 = _errs10 === errors;
                                }
                                else {
                                    var valid1 = true;
                                }
                                if (valid1) {
                                    if (data.roleID !== undefined) {
                                        let data5 = data.roleID;
                                        const _errs12 = errors;
                                        if (errors === _errs12) {
                                            if (errors === _errs12) {
                                                if (typeof data5 === 'string') {
                                                    if (!formats0.test(data5)) {
                                                        validate24.errors = [
                                                            {
                                                                instancePath: instancePath + '/roleID',
                                                                schemaPath: '#/properties/roleID/format',
                                                                keyword: 'format',
                                                                params: { format: 'uuid' },
                                                                message: 'must match format "' + 'uuid' + '"'
                                                            }
                                                        ];
                                                        return false;
                                                    }
                                                }
                                                else {
                                                    validate24.errors = [
                                                        {
                                                            instancePath: instancePath + '/roleID',
                                                            schemaPath: '#/properties/roleID/type',
                                                            keyword: 'type',
                                                            params: { type: 'string' },
                                                            message: 'must be string'
                                                        }
                                                    ];
                                                    return false;
                                                }
                                            }
                                        }
                                        var valid1 = _errs12 === errors;
                                    }
                                    else {
                                        var valid1 = true;
                                    }
                                    if (valid1) {
                                        if (data.supportUser !== undefined) {
                                            const _errs14 = errors;
                                            if (typeof data.supportUser !== 'boolean') {
                                                validate24.errors = [
                                                    {
                                                        instancePath: instancePath + '/supportUser',
                                                        schemaPath: '#/properties/supportUser/type',
                                                        keyword: 'type',
                                                        params: { type: 'boolean' },
                                                        message: 'must be boolean'
                                                    }
                                                ];
                                                return false;
                                            }
                                            var valid1 = _errs14 === errors;
                                        }
                                        else {
                                            var valid1 = true;
                                        }
                                        if (valid1) {
                                            if (data.currentRoleID !== undefined) {
                                                let data7 = data.currentRoleID;
                                                const _errs16 = errors;
                                                if (errors === _errs16) {
                                                    if (errors === _errs16) {
                                                        if (typeof data7 === 'string') {
                                                            if (!formats0.test(data7)) {
                                                                validate24.errors = [
                                                                    {
                                                                        instancePath: instancePath + '/currentRoleID',
                                                                        schemaPath: '#/properties/currentRoleID/format',
                                                                        keyword: 'format',
                                                                        params: { format: 'uuid' },
                                                                        message: 'must match format "' + 'uuid' + '"'
                                                                    }
                                                                ];
                                                                return false;
                                                            }
                                                        }
                                                        else {
                                                            validate24.errors = [
                                                                {
                                                                    instancePath: instancePath + '/currentRoleID',
                                                                    schemaPath: '#/properties/currentRoleID/type',
                                                                    keyword: 'type',
                                                                    params: { type: 'string' },
                                                                    message: 'must be string'
                                                                }
                                                            ];
                                                            return false;
                                                        }
                                                    }
                                                }
                                                var valid1 = _errs16 === errors;
                                            }
                                            else {
                                                var valid1 = true;
                                            }
                                            if (valid1) {
                                                if (data.createdAt !== undefined) {
                                                    let data8 = data.createdAt;
                                                    const _errs18 = errors;
                                                    if (errors === _errs18) {
                                                        if (errors === _errs18) {
                                                            if (typeof data8 === 'string') {
                                                                if (!formats8.validate(data8)) {
                                                                    validate24.errors = [
                                                                        {
                                                                            instancePath: instancePath + '/createdAt',
                                                                            schemaPath: '#/properties/createdAt/format',
                                                                            keyword: 'format',
                                                                            params: { format: 'date-time' },
                                                                            message: 'must match format "' + 'date-time' + '"'
                                                                        }
                                                                    ];
                                                                    return false;
                                                                }
                                                            }
                                                            else {
                                                                validate24.errors = [
                                                                    {
                                                                        instancePath: instancePath + '/createdAt',
                                                                        schemaPath: '#/properties/createdAt/type',
                                                                        keyword: 'type',
                                                                        params: { type: 'string' },
                                                                        message: 'must be string'
                                                                    }
                                                                ];
                                                                return false;
                                                            }
                                                        }
                                                    }
                                                    var valid1 = _errs18 === errors;
                                                }
                                                else {
                                                    var valid1 = true;
                                                }
                                                if (valid1) {
                                                    if (data.acceptedAt !== undefined) {
                                                        let data9 = data.acceptedAt;
                                                        const _errs20 = errors;
                                                        if (errors === _errs20) {
                                                            if (errors === _errs20) {
                                                                if (typeof data9 === 'string') {
                                                                    if (!formats8.validate(data9)) {
                                                                        validate24.errors = [
                                                                            {
                                                                                instancePath: instancePath + '/acceptedAt',
                                                                                schemaPath: '#/properties/acceptedAt/format',
                                                                                keyword: 'format',
                                                                                params: { format: 'date-time' },
                                                                                message: 'must match format "' + 'date-time' + '"'
                                                                            }
                                                                        ];
                                                                        return false;
                                                                    }
                                                                }
                                                                else {
                                                                    validate24.errors = [
                                                                        {
                                                                            instancePath: instancePath + '/acceptedAt',
                                                                            schemaPath: '#/properties/acceptedAt/type',
                                                                            keyword: 'type',
                                                                            params: { type: 'string' },
                                                                            message: 'must be string'
                                                                        }
                                                                    ];
                                                                    return false;
                                                                }
                                                            }
                                                        }
                                                        var valid1 = _errs20 === errors;
                                                    }
                                                    else {
                                                        var valid1 = true;
                                                    }
                                                    if (valid1) {
                                                        if (data.rejectedAt !== undefined) {
                                                            let data10 = data.rejectedAt;
                                                            const _errs22 = errors;
                                                            if (errors === _errs22) {
                                                                if (errors === _errs22) {
                                                                    if (typeof data10 === 'string') {
                                                                        if (!formats8.validate(data10)) {
                                                                            validate24.errors = [
                                                                                {
                                                                                    instancePath: instancePath + '/rejectedAt',
                                                                                    schemaPath: '#/properties/rejectedAt/format',
                                                                                    keyword: 'format',
                                                                                    params: { format: 'date-time' },
                                                                                    message: 'must match format "' + 'date-time' + '"'
                                                                                }
                                                                            ];
                                                                            return false;
                                                                        }
                                                                    }
                                                                    else {
                                                                        validate24.errors = [
                                                                            {
                                                                                instancePath: instancePath + '/rejectedAt',
                                                                                schemaPath: '#/properties/rejectedAt/type',
                                                                                keyword: 'type',
                                                                                params: { type: 'string' },
                                                                                message: 'must be string'
                                                                            }
                                                                        ];
                                                                        return false;
                                                                    }
                                                                }
                                                            }
                                                            var valid1 = _errs22 === errors;
                                                        }
                                                        else {
                                                            var valid1 = true;
                                                        }
                                                    }
                                                }
                                            }
                                        }
                                    }
                                }
                            }
                        }
                    }
                }
            }
        }
        else {
            validate24.errors = [
                { instancePath, schemaPath: '#/type', keyword: 'type', params: { type: 'object' }, message: 'must be object' }
            ];
            return false;
        }
    }
    validate24.errors = vErrors;
    return errors === 0;
}
function validate23(data, { instancePath = '', parentData, parentDataProperty, rootData = data } = {}) {
    /*# sourceURL="urn:wisepipe-domain-authorize:OrgUserInviteInfo" */ let vErrors = null;
    let errors = 0;
    if (errors === 0) {
        if (data && typeof data == 'object' && !Array.isArray(data)) {
            let missing0;
            if ((data.isTemp === undefined && (missing0 = 'isTemp')) ||
                (data.orgUserInvites === undefined && (missing0 = 'orgUserInvites'))) {
                validate23.errors = [
                    {
                        instancePath,
                        schemaPath: '#/required',
                        keyword: 'required',
                        params: { missingProperty: missing0 },
                        message: "must have required property '" + missing0 + "'"
                    }
                ];
                return false;
            }
            else {
                if (data.isTemp !== undefined) {
                    const _errs1 = errors;
                    if (typeof data.isTemp !== 'boolean') {
                        validate23.errors = [
                            {
                                instancePath: instancePath + '/isTemp',
                                schemaPath: '#/properties/isTemp/type',
                                keyword: 'type',
                                params: { type: 'boolean' },
                                message: 'must be boolean'
                            }
                        ];
                        return false;
                    }
                    var valid0 = _errs1 === errors;
                }
                else {
                    var valid0 = true;
                }
                if (valid0) {
                    if (data.orgUserInvites !== undefined) {
                        let data1 = data.orgUserInvites;
                        const _errs3 = errors;
                        if (errors === _errs3) {
                            if (Array.isArray(data1)) {
                                var valid1 = true;
                                const len0 = data1.length;
                                for (let i0 = 0; i0 < len0; i0++) {
                                    const _errs5 = errors;
                                    if (!validate24(data1[i0], {
                                        instancePath: instancePath + '/orgUserInvites/' + i0,
                                        parentData: data1,
                                        parentDataProperty: i0,
                                        rootData
                                    })) {
                                        vErrors = vErrors === null ? validate24.errors : vErrors.concat(validate24.errors);
                                        errors = vErrors.length;
                                    }
                                    var valid1 = _errs5 === errors;
                                    if (!valid1) {
                                        break;
                                    }
                                }
                            }
                            else {
                                validate23.errors = [
                                    {
                                        instancePath: instancePath + '/orgUserInvites',
                                        schemaPath: '#/properties/orgUserInvites/type',
                                        keyword: 'type',
                                        params: { type: 'array' },
                                        message: 'must be array'
                                    }
                                ];
                                return false;
                            }
                        }
                        var valid0 = _errs3 === errors;
                    }
                    else {
                        var valid0 = true;
                    }
                }
            }
        }
        else {
            validate23.errors = [
                { instancePath, schemaPath: '#/type', keyword: 'type', params: { type: 'object' }, message: 'must be object' }
            ];
            return false;
        }
    }
    validate23.errors = vErrors;
    return errors === 0;
}
export const orgUserInviteSchemaValidation = validate24;
export const orgUserSchemaValidation = validate27;
const schema44 = {
    $id: 'urn:wisepipe-domain-authorize:OrgUser',
    type: 'object',
    properties: { id: { type: 'string', format: 'uuid' } },
    required: ['id']
};
function validate27(data, { instancePath = '', parentData, parentDataProperty, rootData = data } = {}) {
    /*# sourceURL="urn:wisepipe-domain-authorize:OrgUser" */ let vErrors = null;
    let errors = 0;
    if (errors === 0) {
        if (data && typeof data == 'object' && !Array.isArray(data)) {
            let missing0;
            if (data.id === undefined && (missing0 = 'id')) {
                validate27.errors = [
                    {
                        instancePath,
                        schemaPath: '#/required',
                        keyword: 'required',
                        params: { missingProperty: missing0 },
                        message: "must have required property '" + missing0 + "'"
                    }
                ];
                return false;
            }
            else {
                if (data.id !== undefined) {
                    let data0 = data.id;
                    const _errs1 = errors;
                    if (errors === _errs1) {
                        if (errors === _errs1) {
                            if (typeof data0 === 'string') {
                                if (!formats0.test(data0)) {
                                    validate27.errors = [
                                        {
                                            instancePath: instancePath + '/id',
                                            schemaPath: '#/properties/id/format',
                                            keyword: 'format',
                                            params: { format: 'uuid' },
                                            message: 'must match format "' + 'uuid' + '"'
                                        }
                                    ];
                                    return false;
                                }
                            }
                            else {
                                validate27.errors = [
                                    {
                                        instancePath: instancePath + '/id',
                                        schemaPath: '#/properties/id/type',
                                        keyword: 'type',
                                        params: { type: 'string' },
                                        message: 'must be string'
                                    }
                                ];
                                return false;
                            }
                        }
                    }
                }
            }
        }
        else {
            validate27.errors = [
                { instancePath, schemaPath: '#/type', keyword: 'type', params: { type: 'object' }, message: 'must be object' }
            ];
            return false;
        }
    }
    validate27.errors = vErrors;
    return errors === 0;
}
export const permissionSchemaValidation = validate28;
const schema45 = {
    $id: 'urn:wisepipe-domain-authorize:Permission',
    type: 'object',
    properties: {
        resourceType: { type: 'number', enum: [1, 2, 3, 4, 5, 6, 7, 8] },
        resourceID: { type: 'string', minLength: 1 },
        action: { type: 'number', enum: [1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11] },
        level: { type: 'integer', minimum: 0 }
    },
    required: ['resourceType', 'resourceID', 'action']
};
function validate28(data, { instancePath = '', parentData, parentDataProperty, rootData = data } = {}) {
    /*# sourceURL="urn:wisepipe-domain-authorize:Permission" */ let vErrors = null;
    let errors = 0;
    if (errors === 0) {
        if (data && typeof data == 'object' && !Array.isArray(data)) {
            let missing0;
            if ((data.resourceType === undefined && (missing0 = 'resourceType')) ||
                (data.resourceID === undefined && (missing0 = 'resourceID')) ||
                (data.action === undefined && (missing0 = 'action'))) {
                validate28.errors = [
                    {
                        instancePath,
                        schemaPath: '#/required',
                        keyword: 'required',
                        params: { missingProperty: missing0 },
                        message: "must have required property '" + missing0 + "'"
                    }
                ];
                return false;
            }
            else {
                if (data.resourceType !== undefined) {
                    let data0 = data.resourceType;
                    const _errs1 = errors;
                    if (!(typeof data0 == 'number')) {
                        validate28.errors = [
                            {
                                instancePath: instancePath + '/resourceType',
                                schemaPath: '#/properties/resourceType/type',
                                keyword: 'type',
                                params: { type: 'number' },
                                message: 'must be number'
                            }
                        ];
                        return false;
                    }
                    if (!(data0 === 1 ||
                        data0 === 2 ||
                        data0 === 3 ||
                        data0 === 4 ||
                        data0 === 5 ||
                        data0 === 6 ||
                        data0 === 7 ||
                        data0 === 8)) {
                        validate28.errors = [
                            {
                                instancePath: instancePath + '/resourceType',
                                schemaPath: '#/properties/resourceType/enum',
                                keyword: 'enum',
                                params: { allowedValues: schema45.properties.resourceType.enum },
                                message: 'must be equal to one of the allowed values'
                            }
                        ];
                        return false;
                    }
                    var valid0 = _errs1 === errors;
                }
                else {
                    var valid0 = true;
                }
                if (valid0) {
                    if (data.resourceID !== undefined) {
                        let data1 = data.resourceID;
                        const _errs3 = errors;
                        if (errors === _errs3) {
                            if (typeof data1 === 'string') {
                                if (func2(data1) < 1) {
                                    validate28.errors = [
                                        {
                                            instancePath: instancePath + '/resourceID',
                                            schemaPath: '#/properties/resourceID/minLength',
                                            keyword: 'minLength',
                                            params: { limit: 1 },
                                            message: 'must NOT have fewer than 1 characters'
                                        }
                                    ];
                                    return false;
                                }
                            }
                            else {
                                validate28.errors = [
                                    {
                                        instancePath: instancePath + '/resourceID',
                                        schemaPath: '#/properties/resourceID/type',
                                        keyword: 'type',
                                        params: { type: 'string' },
                                        message: 'must be string'
                                    }
                                ];
                                return false;
                            }
                        }
                        var valid0 = _errs3 === errors;
                    }
                    else {
                        var valid0 = true;
                    }
                    if (valid0) {
                        if (data.action !== undefined) {
                            let data2 = data.action;
                            const _errs5 = errors;
                            if (!(typeof data2 == 'number')) {
                                validate28.errors = [
                                    {
                                        instancePath: instancePath + '/action',
                                        schemaPath: '#/properties/action/type',
                                        keyword: 'type',
                                        params: { type: 'number' },
                                        message: 'must be number'
                                    }
                                ];
                                return false;
                            }
                            if (!(data2 === 1 ||
                                data2 === 2 ||
                                data2 === 3 ||
                                data2 === 4 ||
                                data2 === 5 ||
                                data2 === 6 ||
                                data2 === 7 ||
                                data2 === 8 ||
                                data2 === 9 ||
                                data2 === 10 ||
                                data2 === 11)) {
                                validate28.errors = [
                                    {
                                        instancePath: instancePath + '/action',
                                        schemaPath: '#/properties/action/enum',
                                        keyword: 'enum',
                                        params: { allowedValues: schema45.properties.action.enum },
                                        message: 'must be equal to one of the allowed values'
                                    }
                                ];
                                return false;
                            }
                            var valid0 = _errs5 === errors;
                        }
                        else {
                            var valid0 = true;
                        }
                        if (valid0) {
                            if (data.level !== undefined) {
                                let data3 = data.level;
                                const _errs7 = errors;
                                if (!(typeof data3 == 'number' && !(data3 % 1) && !isNaN(data3))) {
                                    validate28.errors = [
                                        {
                                            instancePath: instancePath + '/level',
                                            schemaPath: '#/properties/level/type',
                                            keyword: 'type',
                                            params: { type: 'integer' },
                                            message: 'must be integer'
                                        }
                                    ];
                                    return false;
                                }
                                if (errors === _errs7) {
                                    if (typeof data3 == 'number') {
                                        if (data3 < 0 || isNaN(data3)) {
                                            validate28.errors = [
                                                {
                                                    instancePath: instancePath + '/level',
                                                    schemaPath: '#/properties/level/minimum',
                                                    keyword: 'minimum',
                                                    params: { comparison: '>=', limit: 0 },
                                                    message: 'must be >= 0'
                                                }
                                            ];
                                            return false;
                                        }
                                    }
                                }
                                var valid0 = _errs7 === errors;
                            }
                            else {
                                var valid0 = true;
                            }
                        }
                    }
                }
            }
        }
        else {
            validate28.errors = [
                { instancePath, schemaPath: '#/type', keyword: 'type', params: { type: 'object' }, message: 'must be object' }
            ];
            return false;
        }
    }
    validate28.errors = vErrors;
    return errors === 0;
}
export const resourceSchemaValidation = validate29;
const schema46 = {
    $id: 'urn:wisepipe-domain-authorize:Resource',
    type: 'object',
    properties: {
        type: { type: 'number', enum: [1, 2, 3, 4, 5, 6, 7, 8] },
        id: { type: 'string', minLength: 1 },
        name: { type: 'string', minLength: 1 },
        createdAt: { type: 'string', format: 'date-time' }
    },
    required: ['type', 'id', 'name', 'createdAt']
};
function validate29(data, { instancePath = '', parentData, parentDataProperty, rootData = data } = {}) {
    /*# sourceURL="urn:wisepipe-domain-authorize:Resource" */ let vErrors = null;
    let errors = 0;
    if (errors === 0) {
        if (data && typeof data == 'object' && !Array.isArray(data)) {
            let missing0;
            if ((data.type === undefined && (missing0 = 'type')) ||
                (data.id === undefined && (missing0 = 'id')) ||
                (data.name === undefined && (missing0 = 'name')) ||
                (data.createdAt === undefined && (missing0 = 'createdAt'))) {
                validate29.errors = [
                    {
                        instancePath,
                        schemaPath: '#/required',
                        keyword: 'required',
                        params: { missingProperty: missing0 },
                        message: "must have required property '" + missing0 + "'"
                    }
                ];
                return false;
            }
            else {
                if (data.type !== undefined) {
                    let data0 = data.type;
                    const _errs1 = errors;
                    if (!(typeof data0 == 'number')) {
                        validate29.errors = [
                            {
                                instancePath: instancePath + '/type',
                                schemaPath: '#/properties/type/type',
                                keyword: 'type',
                                params: { type: 'number' },
                                message: 'must be number'
                            }
                        ];
                        return false;
                    }
                    if (!(data0 === 1 ||
                        data0 === 2 ||
                        data0 === 3 ||
                        data0 === 4 ||
                        data0 === 5 ||
                        data0 === 6 ||
                        data0 === 7 ||
                        data0 === 8)) {
                        validate29.errors = [
                            {
                                instancePath: instancePath + '/type',
                                schemaPath: '#/properties/type/enum',
                                keyword: 'enum',
                                params: { allowedValues: schema46.properties.type.enum },
                                message: 'must be equal to one of the allowed values'
                            }
                        ];
                        return false;
                    }
                    var valid0 = _errs1 === errors;
                }
                else {
                    var valid0 = true;
                }
                if (valid0) {
                    if (data.id !== undefined) {
                        let data1 = data.id;
                        const _errs3 = errors;
                        if (errors === _errs3) {
                            if (typeof data1 === 'string') {
                                if (func2(data1) < 1) {
                                    validate29.errors = [
                                        {
                                            instancePath: instancePath + '/id',
                                            schemaPath: '#/properties/id/minLength',
                                            keyword: 'minLength',
                                            params: { limit: 1 },
                                            message: 'must NOT have fewer than 1 characters'
                                        }
                                    ];
                                    return false;
                                }
                            }
                            else {
                                validate29.errors = [
                                    {
                                        instancePath: instancePath + '/id',
                                        schemaPath: '#/properties/id/type',
                                        keyword: 'type',
                                        params: { type: 'string' },
                                        message: 'must be string'
                                    }
                                ];
                                return false;
                            }
                        }
                        var valid0 = _errs3 === errors;
                    }
                    else {
                        var valid0 = true;
                    }
                    if (valid0) {
                        if (data.name !== undefined) {
                            let data2 = data.name;
                            const _errs5 = errors;
                            if (errors === _errs5) {
                                if (typeof data2 === 'string') {
                                    if (func2(data2) < 1) {
                                        validate29.errors = [
                                            {
                                                instancePath: instancePath + '/name',
                                                schemaPath: '#/properties/name/minLength',
                                                keyword: 'minLength',
                                                params: { limit: 1 },
                                                message: 'must NOT have fewer than 1 characters'
                                            }
                                        ];
                                        return false;
                                    }
                                }
                                else {
                                    validate29.errors = [
                                        {
                                            instancePath: instancePath + '/name',
                                            schemaPath: '#/properties/name/type',
                                            keyword: 'type',
                                            params: { type: 'string' },
                                            message: 'must be string'
                                        }
                                    ];
                                    return false;
                                }
                            }
                            var valid0 = _errs5 === errors;
                        }
                        else {
                            var valid0 = true;
                        }
                        if (valid0) {
                            if (data.createdAt !== undefined) {
                                let data3 = data.createdAt;
                                const _errs7 = errors;
                                if (errors === _errs7) {
                                    if (errors === _errs7) {
                                        if (typeof data3 === 'string') {
                                            if (!formats8.validate(data3)) {
                                                validate29.errors = [
                                                    {
                                                        instancePath: instancePath + '/createdAt',
                                                        schemaPath: '#/properties/createdAt/format',
                                                        keyword: 'format',
                                                        params: { format: 'date-time' },
                                                        message: 'must match format "' + 'date-time' + '"'
                                                    }
                                                ];
                                                return false;
                                            }
                                        }
                                        else {
                                            validate29.errors = [
                                                {
                                                    instancePath: instancePath + '/createdAt',
                                                    schemaPath: '#/properties/createdAt/type',
                                                    keyword: 'type',
                                                    params: { type: 'string' },
                                                    message: 'must be string'
                                                }
                                            ];
                                            return false;
                                        }
                                    }
                                }
                                var valid0 = _errs7 === errors;
                            }
                            else {
                                var valid0 = true;
                            }
                        }
                    }
                }
            }
        }
        else {
            validate29.errors = [
                { instancePath, schemaPath: '#/type', keyword: 'type', params: { type: 'object' }, message: 'must be object' }
            ];
            return false;
        }
    }
    validate29.errors = vErrors;
    return errors === 0;
}
export const roleHeaderSchemaValidation = validate30;
const schema47 = {
    $id: 'urn:wisepipe-domain-authorize:RoleHeader',
    type: 'object',
    properties: { id: { type: 'string', format: 'uuid' }, name: { type: 'string', minLength: 1 } },
    required: ['id', 'name']
};
function validate30(data, { instancePath = '', parentData, parentDataProperty, rootData = data } = {}) {
    /*# sourceURL="urn:wisepipe-domain-authorize:RoleHeader" */ let vErrors = null;
    let errors = 0;
    if (errors === 0) {
        if (data && typeof data == 'object' && !Array.isArray(data)) {
            let missing0;
            if ((data.id === undefined && (missing0 = 'id')) || (data.name === undefined && (missing0 = 'name'))) {
                validate30.errors = [
                    {
                        instancePath,
                        schemaPath: '#/required',
                        keyword: 'required',
                        params: { missingProperty: missing0 },
                        message: "must have required property '" + missing0 + "'"
                    }
                ];
                return false;
            }
            else {
                if (data.id !== undefined) {
                    let data0 = data.id;
                    const _errs1 = errors;
                    if (errors === _errs1) {
                        if (errors === _errs1) {
                            if (typeof data0 === 'string') {
                                if (!formats0.test(data0)) {
                                    validate30.errors = [
                                        {
                                            instancePath: instancePath + '/id',
                                            schemaPath: '#/properties/id/format',
                                            keyword: 'format',
                                            params: { format: 'uuid' },
                                            message: 'must match format "' + 'uuid' + '"'
                                        }
                                    ];
                                    return false;
                                }
                            }
                            else {
                                validate30.errors = [
                                    {
                                        instancePath: instancePath + '/id',
                                        schemaPath: '#/properties/id/type',
                                        keyword: 'type',
                                        params: { type: 'string' },
                                        message: 'must be string'
                                    }
                                ];
                                return false;
                            }
                        }
                    }
                    var valid0 = _errs1 === errors;
                }
                else {
                    var valid0 = true;
                }
                if (valid0) {
                    if (data.name !== undefined) {
                        let data1 = data.name;
                        const _errs3 = errors;
                        if (errors === _errs3) {
                            if (typeof data1 === 'string') {
                                if (func2(data1) < 1) {
                                    validate30.errors = [
                                        {
                                            instancePath: instancePath + '/name',
                                            schemaPath: '#/properties/name/minLength',
                                            keyword: 'minLength',
                                            params: { limit: 1 },
                                            message: 'must NOT have fewer than 1 characters'
                                        }
                                    ];
                                    return false;
                                }
                            }
                            else {
                                validate30.errors = [
                                    {
                                        instancePath: instancePath + '/name',
                                        schemaPath: '#/properties/name/type',
                                        keyword: 'type',
                                        params: { type: 'string' },
                                        message: 'must be string'
                                    }
                                ];
                                return false;
                            }
                        }
                        var valid0 = _errs3 === errors;
                    }
                    else {
                        var valid0 = true;
                    }
                }
            }
        }
        else {
            validate30.errors = [
                { instancePath, schemaPath: '#/type', keyword: 'type', params: { type: 'object' }, message: 'must be object' }
            ];
            return false;
        }
    }
    validate30.errors = vErrors;
    return errors === 0;
}
export const roleSchemaValidation = validate31;
const schema48 = {
    $id: 'urn:wisepipe-domain-authorize:Role',
    type: 'object',
    properties: {
        users: { type: 'array', items: { $ref: 'urn:wisepipe-domain-authorize:OrgUser' }, uniqueItemProperties: ['id'] },
        permissions: { type: 'array', items: { $ref: 'urn:wisepipe-domain-authorize:Permission' } }
    },
    required: ['users', 'permissions']
};
const func18 = ajvEqual;
function validate31(data, { instancePath = '', parentData, parentDataProperty, rootData = data } = {}) {
    /*# sourceURL="urn:wisepipe-domain-authorize:Role" */ let vErrors = null;
    let errors = 0;
    if (errors === 0) {
        if (data && typeof data == 'object' && !Array.isArray(data)) {
            let missing0;
            if ((data.users === undefined && (missing0 = 'users')) ||
                (data.permissions === undefined && (missing0 = 'permissions'))) {
                validate31.errors = [
                    {
                        instancePath,
                        schemaPath: '#/required',
                        keyword: 'required',
                        params: { missingProperty: missing0 },
                        message: "must have required property '" + missing0 + "'"
                    }
                ];
                return false;
            }
            else {
                if (data.users !== undefined) {
                    let data0 = data.users;
                    const _errs1 = errors;
                    if (errors === _errs1) {
                        if (Array.isArray(data0)) {
                            var valid1 = true;
                            const len0 = data0.length;
                            for (let i0 = 0; i0 < len0; i0++) {
                                let data1 = data0[i0];
                                const _errs3 = errors;
                                const _errs4 = errors;
                                if (errors === _errs4) {
                                    if (data1 && typeof data1 == 'object' && !Array.isArray(data1)) {
                                        let missing1;
                                        if (data1.id === undefined && (missing1 = 'id')) {
                                            validate31.errors = [
                                                {
                                                    instancePath: instancePath + '/users/' + i0,
                                                    schemaPath: 'urn:wisepipe-domain-authorize:OrgUser/required',
                                                    keyword: 'required',
                                                    params: { missingProperty: missing1 },
                                                    message: "must have required property '" + missing1 + "'"
                                                }
                                            ];
                                            return false;
                                        }
                                        else {
                                            if (data1.id !== undefined) {
                                                let data2 = data1.id;
                                                const _errs6 = errors;
                                                if (errors === _errs6) {
                                                    if (errors === _errs6) {
                                                        if (typeof data2 === 'string') {
                                                            if (!formats0.test(data2)) {
                                                                validate31.errors = [
                                                                    {
                                                                        instancePath: instancePath + '/users/' + i0 + '/id',
                                                                        schemaPath: 'urn:wisepipe-domain-authorize:OrgUser/properties/id/format',
                                                                        keyword: 'format',
                                                                        params: { format: 'uuid' },
                                                                        message: 'must match format "' + 'uuid' + '"'
                                                                    }
                                                                ];
                                                                return false;
                                                            }
                                                        }
                                                        else {
                                                            validate31.errors = [
                                                                {
                                                                    instancePath: instancePath + '/users/' + i0 + '/id',
                                                                    schemaPath: 'urn:wisepipe-domain-authorize:OrgUser/properties/id/type',
                                                                    keyword: 'type',
                                                                    params: { type: 'string' },
                                                                    message: 'must be string'
                                                                }
                                                            ];
                                                            return false;
                                                        }
                                                    }
                                                }
                                            }
                                        }
                                    }
                                    else {
                                        validate31.errors = [
                                            {
                                                instancePath: instancePath + '/users/' + i0,
                                                schemaPath: 'urn:wisepipe-domain-authorize:OrgUser/type',
                                                keyword: 'type',
                                                params: { type: 'object' },
                                                message: 'must be object'
                                            }
                                        ];
                                        return false;
                                    }
                                }
                                var valid1 = _errs3 === errors;
                                if (!valid1) {
                                    break;
                                }
                            }
                            if (valid1) {
                                const keys0 = schema48.properties.users.uniqueItemProperties;
                                let k0;
                                let i1 = data0.length;
                                let j0;
                                if (i1 > 1) {
                                    outer0: for (k0 = 0; k0 < keys0.length; k0++) {
                                        let key0 = keys0[k0];
                                        for (i1 = data0.length; i1--;) {
                                            let x0 = data0[i1];
                                            if (!(x0 && typeof x0 == 'object' && !Array.isArray(x0))) {
                                                continue;
                                            }
                                            for (j0 = i1; j0--;) {
                                                let y0 = data0[j0];
                                                if (y0 && typeof y0 == 'object' && !Array.isArray(y0) && func18(x0[key0], y0[key0])) {
                                                    validate31.errors = [
                                                        {
                                                            instancePath: instancePath + '/users',
                                                            schemaPath: '#/properties/users/uniqueItemProperties',
                                                            keyword: 'uniqueItemProperties',
                                                            params: {},
                                                            message: 'must pass "uniqueItemProperties" keyword validation'
                                                        }
                                                    ];
                                                    return false;
                                                    break outer0;
                                                }
                                            }
                                        }
                                    }
                                }
                            }
                        }
                        else {
                            validate31.errors = [
                                {
                                    instancePath: instancePath + '/users',
                                    schemaPath: '#/properties/users/type',
                                    keyword: 'type',
                                    params: { type: 'array' },
                                    message: 'must be array'
                                }
                            ];
                            return false;
                        }
                    }
                    var valid0 = _errs1 === errors;
                }
                else {
                    var valid0 = true;
                }
                if (valid0) {
                    if (data.permissions !== undefined) {
                        let data3 = data.permissions;
                        const _errs8 = errors;
                        if (errors === _errs8) {
                            if (Array.isArray(data3)) {
                                var valid5 = true;
                                const len1 = data3.length;
                                for (let i2 = 0; i2 < len1; i2++) {
                                    let data4 = data3[i2];
                                    const _errs10 = errors;
                                    const _errs11 = errors;
                                    if (errors === _errs11) {
                                        if (data4 && typeof data4 == 'object' && !Array.isArray(data4)) {
                                            let missing2;
                                            if ((data4.resourceType === undefined && (missing2 = 'resourceType')) ||
                                                (data4.resourceID === undefined && (missing2 = 'resourceID')) ||
                                                (data4.action === undefined && (missing2 = 'action'))) {
                                                validate31.errors = [
                                                    {
                                                        instancePath: instancePath + '/permissions/' + i2,
                                                        schemaPath: 'urn:wisepipe-domain-authorize:Permission/required',
                                                        keyword: 'required',
                                                        params: { missingProperty: missing2 },
                                                        message: "must have required property '" + missing2 + "'"
                                                    }
                                                ];
                                                return false;
                                            }
                                            else {
                                                if (data4.resourceType !== undefined) {
                                                    let data5 = data4.resourceType;
                                                    const _errs13 = errors;
                                                    if (!(typeof data5 == 'number')) {
                                                        validate31.errors = [
                                                            {
                                                                instancePath: instancePath + '/permissions/' + i2 + '/resourceType',
                                                                schemaPath: 'urn:wisepipe-domain-authorize:Permission/properties/resourceType/type',
                                                                keyword: 'type',
                                                                params: { type: 'number' },
                                                                message: 'must be number'
                                                            }
                                                        ];
                                                        return false;
                                                    }
                                                    if (!(data5 === 1 ||
                                                        data5 === 2 ||
                                                        data5 === 3 ||
                                                        data5 === 4 ||
                                                        data5 === 5 ||
                                                        data5 === 6 ||
                                                        data5 === 7 ||
                                                        data5 === 8)) {
                                                        validate31.errors = [
                                                            {
                                                                instancePath: instancePath + '/permissions/' + i2 + '/resourceType',
                                                                schemaPath: 'urn:wisepipe-domain-authorize:Permission/properties/resourceType/enum',
                                                                keyword: 'enum',
                                                                params: { allowedValues: schema45.properties.resourceType.enum },
                                                                message: 'must be equal to one of the allowed values'
                                                            }
                                                        ];
                                                        return false;
                                                    }
                                                    var valid7 = _errs13 === errors;
                                                }
                                                else {
                                                    var valid7 = true;
                                                }
                                                if (valid7) {
                                                    if (data4.resourceID !== undefined) {
                                                        let data6 = data4.resourceID;
                                                        const _errs15 = errors;
                                                        if (errors === _errs15) {
                                                            if (typeof data6 === 'string') {
                                                                if (func2(data6) < 1) {
                                                                    validate31.errors = [
                                                                        {
                                                                            instancePath: instancePath + '/permissions/' + i2 + '/resourceID',
                                                                            schemaPath: 'urn:wisepipe-domain-authorize:Permission/properties/resourceID/minLength',
                                                                            keyword: 'minLength',
                                                                            params: { limit: 1 },
                                                                            message: 'must NOT have fewer than 1 characters'
                                                                        }
                                                                    ];
                                                                    return false;
                                                                }
                                                            }
                                                            else {
                                                                validate31.errors = [
                                                                    {
                                                                        instancePath: instancePath + '/permissions/' + i2 + '/resourceID',
                                                                        schemaPath: 'urn:wisepipe-domain-authorize:Permission/properties/resourceID/type',
                                                                        keyword: 'type',
                                                                        params: { type: 'string' },
                                                                        message: 'must be string'
                                                                    }
                                                                ];
                                                                return false;
                                                            }
                                                        }
                                                        var valid7 = _errs15 === errors;
                                                    }
                                                    else {
                                                        var valid7 = true;
                                                    }
                                                    if (valid7) {
                                                        if (data4.action !== undefined) {
                                                            let data7 = data4.action;
                                                            const _errs17 = errors;
                                                            if (!(typeof data7 == 'number')) {
                                                                validate31.errors = [
                                                                    {
                                                                        instancePath: instancePath + '/permissions/' + i2 + '/action',
                                                                        schemaPath: 'urn:wisepipe-domain-authorize:Permission/properties/action/type',
                                                                        keyword: 'type',
                                                                        params: { type: 'number' },
                                                                        message: 'must be number'
                                                                    }
                                                                ];
                                                                return false;
                                                            }
                                                            if (!(data7 === 1 ||
                                                                data7 === 2 ||
                                                                data7 === 3 ||
                                                                data7 === 4 ||
                                                                data7 === 5 ||
                                                                data7 === 6 ||
                                                                data7 === 7 ||
                                                                data7 === 8 ||
                                                                data7 === 9 ||
                                                                data7 === 10 ||
                                                                data7 === 11)) {
                                                                validate31.errors = [
                                                                    {
                                                                        instancePath: instancePath + '/permissions/' + i2 + '/action',
                                                                        schemaPath: 'urn:wisepipe-domain-authorize:Permission/properties/action/enum',
                                                                        keyword: 'enum',
                                                                        params: { allowedValues: schema45.properties.action.enum },
                                                                        message: 'must be equal to one of the allowed values'
                                                                    }
                                                                ];
                                                                return false;
                                                            }
                                                            var valid7 = _errs17 === errors;
                                                        }
                                                        else {
                                                            var valid7 = true;
                                                        }
                                                        if (valid7) {
                                                            if (data4.level !== undefined) {
                                                                let data8 = data4.level;
                                                                const _errs19 = errors;
                                                                if (!(typeof data8 == 'number' && !(data8 % 1) && !isNaN(data8))) {
                                                                    validate31.errors = [
                                                                        {
                                                                            instancePath: instancePath + '/permissions/' + i2 + '/level',
                                                                            schemaPath: 'urn:wisepipe-domain-authorize:Permission/properties/level/type',
                                                                            keyword: 'type',
                                                                            params: { type: 'integer' },
                                                                            message: 'must be integer'
                                                                        }
                                                                    ];
                                                                    return false;
                                                                }
                                                                if (errors === _errs19) {
                                                                    if (typeof data8 == 'number') {
                                                                        if (data8 < 0 || isNaN(data8)) {
                                                                            validate31.errors = [
                                                                                {
                                                                                    instancePath: instancePath + '/permissions/' + i2 + '/level',
                                                                                    schemaPath: 'urn:wisepipe-domain-authorize:Permission/properties/level/minimum',
                                                                                    keyword: 'minimum',
                                                                                    params: { comparison: '>=', limit: 0 },
                                                                                    message: 'must be >= 0'
                                                                                }
                                                                            ];
                                                                            return false;
                                                                        }
                                                                    }
                                                                }
                                                                var valid7 = _errs19 === errors;
                                                            }
                                                            else {
                                                                var valid7 = true;
                                                            }
                                                        }
                                                    }
                                                }
                                            }
                                        }
                                        else {
                                            validate31.errors = [
                                                {
                                                    instancePath: instancePath + '/permissions/' + i2,
                                                    schemaPath: 'urn:wisepipe-domain-authorize:Permission/type',
                                                    keyword: 'type',
                                                    params: { type: 'object' },
                                                    message: 'must be object'
                                                }
                                            ];
                                            return false;
                                        }
                                    }
                                    var valid5 = _errs10 === errors;
                                    if (!valid5) {
                                        break;
                                    }
                                }
                            }
                            else {
                                validate31.errors = [
                                    {
                                        instancePath: instancePath + '/permissions',
                                        schemaPath: '#/properties/permissions/type',
                                        keyword: 'type',
                                        params: { type: 'array' },
                                        message: 'must be array'
                                    }
                                ];
                                return false;
                            }
                        }
                        var valid0 = _errs8 === errors;
                    }
                    else {
                        var valid0 = true;
                    }
                }
            }
        }
        else {
            validate31.errors = [
                { instancePath, schemaPath: '#/type', keyword: 'type', params: { type: 'object' }, message: 'must be object' }
            ];
            return false;
        }
    }
    validate31.errors = vErrors;
    return errors === 0;
}
//# sourceMappingURL=validations.generated.js.map